(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9638,1539],{

/***/ 50755:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-career-report-2023",
      function () {
        return __webpack_require__(42375);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ StyledCopyWrapper; },
/* harmony export */   "It": function() { return /* binding */ StyledShareModalButtons; },
/* harmony export */   "ao": function() { return /* binding */ StyledCopyAnchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    flex-wrap: wrap;\n    > * {\n      width: 2.5rem;\n      height: 2.5rem;\n\n      svg {\n        width: ",
        ";\n        height: ",
        ";\n      }\n\n      &:not(:last-child) {\n        margin-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  padding-right: 2rem;\n  line-height: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledShareModalButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("mdMax"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledCopyAnchor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-724ab933-1"
})(_templateObject1());
var StyledCopyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-2"
})(_templateObject2());


/***/ }),

/***/ 9011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ShareModal": function() { return /* reexport */ ShareModal; },
  "default": function() { return /* binding */ shared_ShareModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/XTwitterIcon.tsx
var XTwitterIcon = __webpack_require__(66334);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/InputText.tsx
var InputText = __webpack_require__(6776);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/shared/ShareModal/ShareModal.styled.ts
var ShareModal_styled = __webpack_require__(80087);
;// CONCATENATED MODULE: ./components/shared/ShareModal/ShareModal.tsx














var ShareModal = function(param) {
    var twitterMessage = param.twitterMessage, telegramMessage = param.telegramMessage, whatsappMessage = param.whatsappMessage, emailMessage = param.emailMessage, emailSubject = param.emailSubject, isOpened = param.isOpened, close = param.close, url = param.url;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var linkInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: isOpened,
        contentLabel: t("share-modal.shareAction"),
        onAfterOpen: function() {
            setCopied(false);
        },
        shouldCloseOnOverlayClick: true,
        onRequestClose: close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            title: t("share-modal.share"),
            onClose: close,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareModal_styled/* StyledShareModalButtons */.It, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "http://twitter.com/share?text=".concat(twitterMessage, "&url=").concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.twitter"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: XTwitterIcon/* faXTwitter */.N
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "https://www.linkedin.com/shareArticle?mini=true&url=".concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.linkedin"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faLinkedin */.D9H
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "https://telegram.me/share/url?url=".concat(encodeURIComponent(url), "&text=").concat(telegramMessage),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.telegram"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faTelegramPlane */.IKq
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "https://api.whatsapp.com/send?text=".concat(whatsappMessage, " ").concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.whatsapp"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faWhatsapp */.VHX
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "mailto:?subject=".concat(encodeURIComponent(emailSubject), "&body=").concat(emailMessage, " ").concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.email"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_solid_svg_icons/* faEnvelope */.FU$
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                        label: "".concat(t("share-modal.copyLink")),
                        forId: "shareLink",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                id: "shareLink",
                                type: "text",
                                value: url,
                                title: url,
                                variant: "copy",
                                readOnly: true,
                                ref: linkInputRef,
                                onClick: function() {
                                    var ref;
                                    (ref = linkInputRef.current) === null || ref === void 0 ? void 0 : ref.select();
                                    document.execCommand("copy");
                                    setCopied(true);
                                    setTimeout(function() {
                                        setCopied(false);
                                    }, 2000);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyWrapper */.E$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                    content: t("share-modal.linkCopy"),
                                    direction: "up",
                                    distance: 65,
                                    isOpen: copied,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyAnchor */.ao, {})
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/shared/ShareModal/index.ts


/* harmony default export */ var shared_ShareModal = (ShareModal);


/***/ }),

/***/ 28619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ StyledContent; },
/* harmony export */   "SO": function() { return /* binding */ StyledTriggerIcon; },
/* harmony export */   "WQ": function() { return /* binding */ StyledSummary; },
/* harmony export */   "X0": function() { return /* binding */ StyledTitle; },
/* harmony export */   "iO": function() { return /* binding */ StyledDetails; },
/* harmony export */   "sB": function() { return /* binding */ StyledAccordion; },
/* harmony export */   "tr": function() { return /* binding */ StyledTrigger; },
/* harmony export */   "wW": function() { return /* binding */ StyledAccordionItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.142;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-appearance: none;\n  color: inherit;\n  cursor: pointer;\n  width: 100%;\n  padding: ",
        " 0;\n  display: flex;\n  align-items: center;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  text-align: left;\n\n  &:focus-visible {\n    ",
        ":before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  padding-left: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    transition: transform 0.3s ease-in-out;\n\n    .is-active & {\n      transform: rotate(180deg);\n      transform-origin: center center;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n\n  p {\n    margin: 0;\n    &:not(:first-child) {\n      margin-top: ",
        ";\n    }\n  }\n\n  ul,\n  ol {\n    margin-left: 1rem;\n  }\n\n  li {\n    list-style-type: disc;\n    margin: 0;\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n\n  img {\n    display: block;\n    margin-top: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n\n    &:not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  }\n\n  figure {\n    margin: 0;\n  }\n\n  figcaption {\n    font-weight: ",
        ";\n    color: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  blockquote {\n    margin: 0;\n    font-style: italic;\n  }\n\n  .slick-track {\n    display: flex;\n    justify-content: center;\n  }\n\n  .slick-slide {\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n\n  .slick-dots {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var StyledAccordion = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-72941c48-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledAccordionItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-1"
})(_templateObject1());
var StyledSummary = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dt.withConfig */ .ZP.dt.withConfig({
    componentId: "sc-72941c48-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledTrigger = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-72941c48-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), StyledTitle, (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
var StyledTriggerIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-5"
})(_templateObject5(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
var StyledDetails = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dd.withConfig */ .ZP.dd.withConfig({
    componentId: "sc-72941c48-6"
})(_templateObject6());
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-7"
})(_templateObject7(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));


/***/ }),

/***/ 71652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _Accordion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28619);
/* harmony import */ var _AccordionItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57449);



var Accordion = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledAccordion */ .sB, {
        children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AccordionItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                summary: item.summary,
                details: item.details,
                active: item.active
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 57449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _Accordion_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28619);






var AccordionItem = function(param) {
    var summary = param.summary, details = param.details, active = param.active;
    var toggleAccordion = function toggleAccordion() {
        setIsActive(function(prev) {
            return !prev;
        });
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(active), isActive = ref[0], setIsActive = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (active) {
            setIsActive(active);
        }
    }, [
        active
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledAccordionItem */ .wW, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledSummary */ .WQ, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledTrigger */ .tr, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                        "is-active": isActive
                    }),
                    onClick: toggleAccordion,
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledTitle */ .X0, {
                            children: summary
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledTriggerIcon */ .SO, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faCaretDown */ .eW2
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledDetails */ .iO, {
                style: {
                    maxHeight: "".concat(isActive ? "1500px" : "0px")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion_styled__WEBPACK_IMPORTED_MODULE_4__/* .StyledContent */ .Hz, {
                    children: details
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 42375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ developer_career_report_2023; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/Button.js
var Button = __webpack_require__(15659);
// EXTERNAL MODULE: ./components/shared/ShareModal/index.ts + 1 modules
var ShareModal = __webpack_require__(9011);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/sectionChart/SectionChart.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  text-align: left;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  margin-top: 0;\n\n  &.isTop {\n    margin-top: -",
        ";\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c502413-0"
})(_templateObject(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4c502413-1"
})(_templateObject1(), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/sectionChart/SectionChart.tsx




var SectionChart = function(param) {
    var title = param.title, children = param.children, desc = param.desc, descExtra = param.descExtra;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                as: "h3",
                children: title
            }),
            desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                className: "isTop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "developer-career-report-2023",
                    i18nKey: desc
                })
            }),
            children,
            descExtra && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "developer-career-report-2023",
                    i18nKey: descExtra
                })
            })
        ]
    });
};
/* harmony default export */ var sectionChart_SectionChart = (SectionChart);

// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/sectionHero/SectionHero.styled.tsx

function SectionHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(180deg, rgba(22, 26, 30, 0) 0%, #161a1e 65.66%);\n  }\n\n  > img {\n    position: absolute;\n    inset: 0;\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n\n    @media (max-width: ",
        ") {\n      &.desktop {\n        display: none;\n      }\n    }\n    @media (min-width: ",
        ") {\n      &.mobile {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    SectionHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n  z-index: 1;\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    text-align: center;\n  }\n"
    ]);
    SectionHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  font-size: ",
        ";\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    gap: ",
        ";\n    align-items: center;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.12;\n  }\n\n  &::before {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n\n    @media (min-width: ",
        ") {\n      width: 7.5rem;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  max-width: ",
        ";\n  margin: auto;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin-top: 0;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  &::before,\n  &::after {\n    content: '';\n    height: 1px;\n    background-color: ",
        ";\n    flex-grow: 1;\n  }\n\n  &::before {\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  gap: ",
        ";\n  padding: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38c3ef54-0"
})(SectionHero_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* screen */.sp)("md"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38c3ef54-1"
})(SectionHero_styled_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("md"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading1 */.nL).withConfig({
    componentId: "sc-38c3ef54-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xs"));
var StyledHeroDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-38c3ef54-3"
})(_templateObject3(), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl2"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38c3ef54-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xl4"));
var StyledDataTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-38c3ef54-5"
})(_templateObject5(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("mdMax"));
var StyledDataList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38c3ef54-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38c3ef54-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("text_default_inverse"));
var StyledDataValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-38c3ef54-8"
})(_templateObject8(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* fontSize */.JB)("xl6"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/sectionHero/SectionHero.tsx




var SectionHero = function(param) {
    var background = param.background, backgroundSm = param.backgroundSm, title = param.title, desc = param.desc, data = param.data;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: background,
                alt: "",
                className: "desktop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: backgroundSm,
                alt: "",
                className: "mobile"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                        as: "h2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2023",
                            i18nKey: title
                        })
                    }),
                    desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroDesc, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2023",
                            i18nKey: desc
                        })
                    }),
                    data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataTitle, {
                                children: t("mandecar23.key-points-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataList, {
                                children: data.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataValue, {
                                                children: item.value
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                    ns: "developer-career-report-2023",
                                                    i18nKey: item.desc
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sectionHero_SectionHero = (SectionHero);

// EXTERNAL MODULE: ./components/shared/RadioButton.tsx
var RadioButton = __webpack_require__(73273);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/switcher/Switcher.styled.tsx

function Switcher_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: 0 0 ",
        ";\n  border: 0;\n  padding: 0;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  legend {\n    font-weight: ",
        ";\n    float: left;\n    padding: 0;\n  }\n"
    ]);
    Switcher_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Switcher_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  &.is-active {\n    display: block;\n  }\n"
    ]);
    Switcher_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwitcher = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
    componentId: "sc-f1ffb830-0"
})(Switcher_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1ffb830-1"
})(Switcher_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/switcher/Switcher.tsx




var Switcher = function(param) {
    var tabsName = param.tabsName, tabs = param.tabs, label = param.label;
    var defaultTabChecked = tabs.findIndex(function(tab) {
        return tab.defaultChecked === true;
    });
    var defaultTabCheckedPosition = defaultTabChecked >= 0 ? defaultTabChecked : 0;
    var ref = (0,react.useState)(tabs[defaultTabCheckedPosition].id), activeTab = ref[0], setActiveTab = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitcher, {
                role: "tablist",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                        children: label
                    }),
                    tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                            name: tabsName,
                            id: tab.id,
                            label: tab.label,
                            "aria-controls": tab.id + "_content",
                            "aria-selected": activeTab === tab.id,
                            onChange: function() {
                                return setActiveTab(tab.id);
                            },
                            checked: activeTab === tab.id
                        }, index);
                    })
                ]
            }),
            tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                    id: tab.id + "_content",
                    role: "tabpanel",
                    "aria-labelledby": tab.id,
                    className: activeTab === tab.id ? "is-active" : "",
                    children: tab.content
                }, index);
            })
        ]
    });
};
/* harmony default export */ var switcher_Switcher = (Switcher);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/methodologyAnchor/MethodologyAnchor.styled.tsx

function MethodologyAnchor_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    MethodologyAnchor_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAnchor = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
    componentId: "sc-88ddec48-0"
})(MethodologyAnchor_styled_templateObject(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* color */.$_)("midnight_300"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/methodologyAnchor/MethodologyAnchor.tsx





var MethodologyAnchor = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAnchor, {
        to: "methodology",
        href: "#methodology",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faInfoCircle */.sqG
            }),
            t("mandecar23.methodology-anchor")
        ]
    });
};
/* harmony default export */ var methodologyAnchor_MethodologyAnchor = (MethodologyAnchor);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/AverageSalaryByRole.styled.tsx

function AverageSalaryByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n"
    ]);
    AverageSalaryByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 4.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var AverageSalaryByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17dae20-0"
})(AverageSalaryByRole_styled_templateObject());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-17dae20-1"
})(AverageSalaryByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17dae20-2"
})(AverageSalaryByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("text_disabled"), (0,theme/* color */.$_)("ylgnbu_03"), (0,theme/* color */.$_)("ylgnbu_04"), (0,theme/* color */.$_)("ylgnbu_05"), (0,theme/* color */.$_)("ylgnbu_06"), (0,theme/* color */.$_)("ylgnbu_07"), (0,theme/* color */.$_)("ylgnbu_08"), (0,theme/* color */.$_)("ylgnbu_09"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/AverageSalaryByRole.tsx





var AverageSalaryByRole = function(param) {
    var experience = param.experience;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var filteredData = SALARYRANGEBYROLEANDEXPERIENCE.filter(function(e) {
        return e.exp === experience;
    });
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "<20K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€20-30K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€31-40K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€41-50K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€51-60K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€61-80K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: ">80K"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: filteredData.map(function(data, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: data.role
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier1),
                                            children: [
                                                data.tier1.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier2),
                                            children: [
                                                data.tier2.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier3),
                                            children: [
                                                data.tier3.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier4),
                                            children: [
                                                data.tier4.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier5),
                                            children: [
                                                data.tier5.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier6),
                                            children: [
                                                data.tier6.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier7),
                                            children: [
                                                data.tier7.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var benefits_AverageSalaryByRole = (AverageSalaryByRole);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(61660);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/LineChart.js
var LineChart = __webpack_require__(32908);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/CartesianGrid.js
var CartesianGrid = __webpack_require__(55484);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(25556);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(3131);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(47857);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Legend.js + 1 modules
var Legend = __webpack_require__(55734);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(63004);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/shared/recharts/Recharts.styled.tsx

function Recharts_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    overflow-x: auto;\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    border-radius: ",
        " !important;\n    flex: 0 0 auto;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n  &.dark {\n    .recharts-text {\n      fill: ",
        ";\n    }\n    .recharts-legend-item-text {\n      color: ",
        " !important;\n    }\n    .recharts-cartesian-axis-line {\n      stroke: ",
        ";\n    }\n  }\n  &.skills {\n    .recharts-text {\n      fill: ",
        ";\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.methodology {\n    .recharts-text {\n      font-size: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.gender-by-role {\n    .recharts-text {\n      font-size: ",
        ";\n    }\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    display: flex !important;\n    align-items: center;\n  }\n\n  &.gender .recharts-legend-item {\n    display: inline-flex !important;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  &.vertical-legend {\n    .recharts-default-legend {\n      flex-direction: column;\n    }\n  }\n\n  &.xAxisLabel {\n    .recharts-cartesian-axis-tick .recharts-text {\n      text-transform: initial;\n    }\n  }\n"
    ]);
    Recharts_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledRecharts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e49697c-0"
})(Recharts_styled_templateObject(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/charts/AverageSalaryByFrameworks.tsx







var AverageSalaryByFrameworks = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locale = (0,router.useRouter)().locale;
    var averageSalaryByFrameworks = AVERAGESALARYBYFRAMEWORKS(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark vertical-legend",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 600,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                        data: averageSalaryByFrameworks,
                        margin: {
                            left: 10,
                            bottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                strokeDasharray: "1 1 ",
                                stroke: "#353241"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                dataKey: "years",
                                tickLine: false,
                                tickMargin: 8,
                                label: {
                                    value: t("mandecar23.benefits.average-salary-language.years-label"),
                                    position: "insideBottom",
                                    offset: -13,
                                    style: {
                                        transformOrigin: "center center"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                tickMargin: 10,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                label: {
                                    value: t("mandecar23.benefits.average-salary-language.salary-label"),
                                    position: "insideLeft",
                                    offset: -8,
                                    angle: -90
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    borderBottom: "1px solid #4d485c",
                                    marginBottom: "6px",
                                    fontWeight: 900
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€" + value.toFixed(1) + "K";
                                },
                                labelFormatter: function(name) {
                                    return name + " " + t("mandecar23.benefits.average-salary-language.years-label");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "vertical",
                                align: "right",
                                verticalAlign: "top",
                                iconType: "square",
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Laravel",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#666666"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Spring Boot",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E7278A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "React",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E41B1E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: ".NET",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E3A702"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Spring",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#65A41E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Angular2+",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#A6761D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Bootstrap",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#D95F02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Express",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1B9D76"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Vue",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "jQuery",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1E77B3"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_AverageSalaryByFrameworks = (AverageSalaryByFrameworks);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/charts/AverageSalaryByLanguage.tsx







var AverageSalaryByLanguage = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locale = (0,router.useRouter)().locale;
    var averageSalaryByLanguage = AVERAGESALARYBYLANGUAGE(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark vertical-legend",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 600,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                        data: averageSalaryByLanguage,
                        margin: {
                            left: 10,
                            bottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                strokeDasharray: "1 1 ",
                                stroke: "#353241"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                dataKey: "years",
                                tickLine: false,
                                tickMargin: 8,
                                label: {
                                    value: t("mandecar23.benefits.average-salary-language.years-label"),
                                    position: "insideBottom",
                                    offset: -13,
                                    style: {
                                        transformOrigin: "center center"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                tickMargin: 10,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                label: {
                                    value: t("mandecar23.benefits.average-salary-language.salary-label"),
                                    position: "insideLeft",
                                    offset: -8,
                                    angle: -90
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    borderBottom: "1px solid #4d485c",
                                    marginBottom: "6px",
                                    fontWeight: 900
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€" + value.toFixed(1) + "K";
                                },
                                labelFormatter: function(label) {
                                    return label + " " + t("mandecar23.benefits.average-salary-language.years-label");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "vertical",
                                align: "right",
                                verticalAlign: "top",
                                iconType: "square",
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "JavaScript",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#666666"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "PHP",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E7278A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "CSS",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E41B1E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "HTML",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E3A702"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "SQL",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#65A41E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Python",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#A6761D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "JAVA",
                                name: "Java",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#D95F02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "C#",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1B9D76"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "C++",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "TypeScript",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1E77B3"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_AverageSalaryByLanguage = (AverageSalaryByLanguage);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/charts/AverageSalaryByOther.tsx







var AverageSalaryByOther = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locale = (0,router.useRouter)().locale;
    var averageSalaryByOther = AVERAGESALARYBYOTHER(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark vertical-legend",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 600,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                        data: averageSalaryByOther,
                        margin: {
                            left: 10,
                            bottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                strokeDasharray: "1 1 ",
                                stroke: "#353241"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                dataKey: "years",
                                tickLine: false,
                                tickMargin: 8,
                                label: {
                                    value: t("mandecar23.benefits.average-salary-language.years-label"),
                                    position: "insideBottom",
                                    offset: -13,
                                    style: {
                                        transformOrigin: "center center"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                tickMargin: 10,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                label: {
                                    value: t("mandecar23.benefits.average-salary-language.salary-label"),
                                    position: "insideLeft",
                                    offset: -8,
                                    angle: -90
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    borderBottom: "1px solid #4d485c",
                                    marginBottom: "6px",
                                    fontWeight: 900
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€" + value.toFixed(1) + "K";
                                },
                                labelFormatter: function(label) {
                                    return label + " " + t("mandecar23.benefits.average-salary-language.years-label");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "vertical",
                                align: "right",
                                verticalAlign: "top",
                                iconType: "square",
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "MongoDB",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#666666"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Jira",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E7278A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Docker",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E41B1E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Git",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E3A702"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Github",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#65A41E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "MySQL",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#A6761D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Linux",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#D95F02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "PostgreSQL",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1B9D76"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "AWS",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "NodeJS",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1E77B3"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_AverageSalaryByOther = (AverageSalaryByOther);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/Benefits.constants.tsx





var HERODATA = function(t) {
    return [
        {
            value: "62%",
            desc: t("mandecar23.benefits.hero.key-point-1")
        },
        {
            value: "€61-63K",
            desc: t("mandecar23.benefits.hero.key-point-2")
        },
        {
            value: "15%",
            desc: t("mandecar23.benefits.hero.key-point-3")
        },
        {
            value: "€10K",
            desc: t("mandecar23.benefits.hero.key-point-4")
        }
    ];
};
var LOCATIONDATA = function(t) {
    return [
        {
            type: "medium",
            value: 24.1,
            label: t("mandecar23.benefits.location.hybrid")
        },
        {
            type: "big",
            value: 62.8,
            label: t("mandecar23.benefits.location.remote")
        },
        {
            type: "small",
            value: 13.1,
            label: t("mandecar23.benefits.location.onsite")
        }
    ];
};
var AVERAGESALARYTABS = function(t) {
    return {
        tabsName: "averageSalary",
        tabs: [
            {
                id: "averageSalaryByLang",
                label: t("mandecar23.benefits.average-salary-language.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_AverageSalaryByLanguage, {})
            },
            {
                id: "averageSalaryByFrameworks",
                label: t("mandecar23.benefits.average-salary-language.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_AverageSalaryByFrameworks, {})
            },
            {
                id: "averageSalaryByOther",
                label: t("mandecar23.benefits.average-salary-language.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_AverageSalaryByOther, {})
            }
        ]
    };
};
var AVERAGESALARYBYLANGUAGE = function(locale) {
    return [
        {
            years: "<2",
            JavaScript: 26.959838585703306,
            PHP: 26.819565217391304,
            CSS: 26.44574175824176,
            HTML: 26.43994413407821,
            SQL: 28.589068825910932,
            Python: 29.57867412140575,
            JAVA: 27.71289537712895,
            "C#": 27.62465373961219,
            "C++": 29.438931297709924,
            TypeScript: 27.85395408163265
        },
        {
            years: "2-5",
            TypeScript: 38.89467312348668,
            PHP: 36.31507592190889,
            HTML: 35.78656639004149,
            Python: 42.17796143250689,
            SQL: 39.24448275862069,
            JAVA: 39.227914110429445,
            "C#": 37.68600682593856,
            JavaScript: 37.44172535211268,
            "C++": 41.14713896457766,
            CSS: 35.50954100051573
        },
        {
            years: "5-10",
            SQL: 51.44762757385855,
            JavaScript: 49.36,
            Python: 54.6529197080292,
            PHP: 45.411162790697674,
            "C#": 47.51067961165049,
            HTML: 46.754262416604895,
            CSS: 46.83733133433283,
            "C++": 49.72931034482759,
            TypeScript: 53.29372197309417,
            JAVA: 51.45797485109199
        },
        {
            years: ">10",
            PHP: 54.013531799729364,
            TypeScript: 63.37091988130564,
            "C#": 56.114285714285714,
            CSS: 52.28588516746411,
            Python: 62.07580445544554,
            "C++": 59.4404255319149,
            HTML: 52.479034810126585,
            SQL: 57.91475166790215,
            JavaScript: 57.33212457337884,
            JAVA: 61.70120537783959
        }
    ];
};
var AVERAGESALARYBYFRAMEWORKS = function(locale) {
    return [
        {
            years: "<2",
            Express: 26.42365887207703,
            Laravel: 25.653333333333332,
            Spring: 27.896907216494846,
            Bootstrap: 25.704011065006913,
            React: 26.859365994236313,
            ".NET": 28.152694610778443,
            "Angular2+": 27.785067873303166,
            "Spring Boot": 27.022184300341298,
            Vue: 27.663352272727273,
            jQuery: 26.386699507389164
        },
        {
            years: "2-5",
            Vue: 38.31072555205047,
            "Angular2+": 38.11573033707865,
            Bootstrap: 33.195736434108525,
            React: 37.91451233842538,
            Laravel: 35.09718309859155,
            Spring: 39.434782608695656,
            jQuery: 34.673969072164944,
            ".NET": 38.53879310344828,
            Express: 35.97525773195876,
            "Spring Boot": 39.83684210526316
        },
        {
            years: "5-10",
            Vue: 50.138297872340424,
            Spring: 50.978794642857146,
            "Spring Boot": 52.065217391304344,
            jQuery: 43.91222222222222,
            Express: 50.329787234042556,
            Laravel: 43.700854700854705,
            ".NET": 47.550970873786405,
            "Angular2+": 48.41112385321101,
            Bootstrap: 43.24153846153846,
            React: 52.19280762564991
        },
        {
            years: ">10",
            ".NET": 56.145596590909086,
            React: 61.713592233009706,
            Laravel: 51.528443113772454,
            "Angular2+": 56.67426273458445,
            Spring: 59.56613372093023,
            Express: 55.743718592964825,
            "Spring Boot": 61.59615384615385,
            jQuery: 49.23575129533678,
            Vue: 56.761904761904766,
            Bootstrap: 48.349184782608695
        }
    ];
};
var AVERAGESALARYBYOTHER = function(locale) {
    return [
        {
            years: "<2",
            PostgreSQL: 27.906370656370655,
            Docker: 29.947674418604652,
            Linux: 28.109686609686612,
            Github: 26.27342747111682,
            MongoDB: 27.574262461851475,
            Jira: 28.406779661016948,
            MySQL: 26.878155339805826,
            AWS: 32.54166666666667,
            NodeJS: 27.079699248120303,
            Git: 26.969317199654277
        },
        {
            years: "2-5",
            NodeJS: 38.49175412293853,
            AWS: 44.96009975062344,
            Git: 38.42718446601942,
            MySQL: 37.55349794238683,
            Docker: 42.66425702811245,
            Linux: 39.56391585760518,
            PostgreSQL: 40.45155502392344,
            Jira: 40.41526520051747,
            MongoDB: 39.076146788990826,
            Github: 37.737381703470035
        },
        {
            years: "5-10",
            Git: 50.1992125984252,
            MySQL: 47.91726332537788,
            Linux: 49.91185897435898,
            NodeJS: 51.55740037950664,
            MongoDB: 52.10184182015168,
            PostgreSQL: 53.20475561426684,
            Jira: 50.63279301745636,
            AWS: 58.11670235546039,
            Docker: 54.03792025019546,
            Github: 53.264642082429496
        },
        {
            years: ">10",
            Github: 63.18678815489749,
            NodeJS: 60.59712230215827,
            Jira: 61.195097037793666,
            Git: 57.13106796116505,
            PostgreSQL: 61.17013129102845,
            MongoDB: 60.85735735735736,
            Docker: 63.84983818770226,
            Linux: 57.38914233576642,
            AWS: 69.12688821752266,
            MySQL: 56.29779874213837
        }
    ];
};
var AVERAGESALARYBYROLE = [
    {
        role: "Product Manager",
        tier1: 0.3129890453834116,
        tier2: 6.964006259780908,
        tier3: 16.118935837245697,
        tier4: 26.76056338028169,
        tier5: 21.439749608763695,
        tier6: 20.81377151799687,
        tier7: 7.589984350547731
    },
    {
        role: "Backend Developer",
        tier1: 7.648828516728963,
        tier2: 22.764153523566414,
        tier3: 23.393199015407056,
        tier4: 21.1869814932993,
        tier5: 12.507977026164646,
        tier6: 9.0801349256997,
        tier7: 3.209043668520376
    },
    {
        role: "Data Scientist",
        tier1: 5.278810408921933,
        tier2: 22.527881040892193,
        tier3: 23.04832713754647,
        tier4: 19.925650557620816,
        tier5: 14.79553903345725,
        tier6: 9.144981412639405,
        tier7: 4.907063197026022
    },
    {
        role: "Engineering Management",
        tier1: 0.8784773060029283,
        tier2: 3.001464128843338,
        tier3: 7.46705710102489,
        tier4: 14.568081991215227,
        tier5: 21.2298682284041,
        tier6: 30.74670571010249,
        tier7: 21.59590043923865
    },
    {
        role: "Full-stack Developer",
        tier1: 8.706022659511031,
        tier2: 28.133571854502087,
        tier3: 23.446630888491356,
        tier4: 18.962432915921287,
        tier5: 10.447227191413237,
        tier6: 7.740011926058438,
        tier7: 2.409063804412641
    },
    {
        role: "Data Analysis & BI",
        tier1: 6.0382916053019144,
        tier2: 23.711340206185564,
        tier3: 23.711340206185564,
        tier4: 21.354933726067745,
        tier5: 13.25478645066274,
        tier6: 8.24742268041237,
        tier7: 3.4609720176730487
    },
    {
        role: "DevOps & Infra. & SRE",
        tier1: 2.7791814047498735,
        tier2: 11.874684183931278,
        tier3: 15.866599292572007,
        tier4: 22.132390096008084,
        tier5: 19.252147549267306,
        tier6: 19.55533097524002,
        tier7: 8.388074785245074
    },
    {
        role: "Tech Lead",
        tier1: 0.6058158319870759,
        tier2: 1.4539579967689822,
        tier3: 7.95638126009693,
        tier4: 21.08239095315024,
        tier5: 24.919224555735056,
        tier6: 29.563812600969307,
        tier7: 14.095315024232633
    },
    {
        role: "SysAdmin",
        tier1: 4.151838671411625,
        tier2: 22.064056939501782,
        tier3: 28.46975088967972,
        tier4: 20.640569395017792,
        tier5: 13.523131672597867,
        tier6: 7.947805456702254,
        tier7: 2.9655990510083043
    },
    {
        role: "QA & Testing Engineer",
        tier1: 7.588739290085679,
        tier2: 27.41738066095471,
        tier3: 25.458996328029375,
        tier4: 17.38066095471236,
        tier5: 12.851897184822523,
        tier6: 6.609547123623011,
        tier7: 2.2031823745410035
    },
    {
        role: "Product Design (UI/UX)",
        tier1: 6.013179571663921,
        tier2: 35.749588138385505,
        tier3: 30.724876441515654,
        tier4: 16.556836902800658,
        tier5: 6.507413509060955,
        tier6: 2.9654036243822075,
        tier7: 1.400329489291598
    },
    {
        role: "Project & Delivery Manager",
        tier1: 0.41284403669724773,
        tier2: 7.844036697247707,
        tier3: 16.376146788990827,
        tier4: 25.963302752293576,
        tier5: 22.06422018348624,
        tier6: 22.477064220183486,
        tier7: 4.81651376146789
    },
    {
        role: "Frontend Developer",
        tier1: 12.58826393961529,
        tier2: 33.19941563184806,
        tier3: 22.58339420501583,
        tier4: 15.497930362795229,
        tier5: 8.375943511078646,
        tier6: 5.746286827367909,
        tier7: 1.8261504747991235
    },
    {
        role: "Software Architect",
        tier1: 2.2087244616234125,
        tier2: 6.018774157923799,
        tier3: 9.99447818884594,
        tier4: 20.706791827719492,
        tier5: 23.743787962451684,
        tier6: 24.29596907785754,
        tier7: 12.534511319712866
    },
    {
        role: "Data Engineer",
        tier1: 3.8724373576309796,
        tier2: 30.220197418375093,
        tier3: 22.39939255884586,
        tier4: 19.665907365223994,
        tier5: 17.084282460136674,
        tier6: 15.261958997722095,
        tier7: 6.302201974183751
    },
    {
        role: "Mobile Developer",
        tier1: 9.57193816884661,
        tier2: 22.05707491082045,
        tier3: 21.284185493460168,
        tier4: 19.738406658739596,
        tier5: 13.3769322235434,
        tier6: 10.523186682520809,
        tier7: 3.2699167657550534
    }
];
// TODO: Build a selector with the experience and get the right data from this object applying a filter over the 'exp' property
var SALARYRANGEBYROLEANDEXPERIENCE = [
    {
        role: "Backend Developer",
        exp: "0-0",
        tier1: 28.65221489161169,
        tier2: 46.842601319509896,
        tier3: 9.142318567389255,
        tier4: 6.4090480678605095,
        tier5: 3.2045240339302548,
        tier6: 2.9217719132893496,
        tier7: 2.35626767200754
    },
    {
        role: "Backend Developer",
        exp: "10-",
        tier1: 0.2570694087403599,
        tier2: 3.2317297098788105,
        tier3: 15.754682335659197,
        tier4: 29.59970620639001,
        tier5: 23.28314359162688,
        tier6: 20.16158648549394,
        tier7: 7.601909658464928
    },
    {
        role: "Backend Developer",
        exp: "-2",
        tier1: 19.80295566502463,
        tier2: 57.487684729064036,
        tier3: 17.733990147783253,
        tier4: 3.0049261083743843,
        tier5: 0.7389162561576355,
        tier6: 0.6896551724137931,
        tier7: 0.24630541871921183
    },
    {
        role: "Backend Developer",
        exp: "2-5",
        tier1: 3.870254330998894,
        tier2: 21.85772207887947,
        tier3: 39.43973461113159,
        tier4: 22.152598599336528,
        tier5: 8.219683007740509,
        tier6: 3.3910799852561744,
        tier7: 0.9583486914854404
    },
    {
        role: "Backend Developer",
        exp: "5-10",
        tier1: 0.9005321326238231,
        tier2: 6.2218583708555055,
        tier3: 24.96930004093328,
        tier4: 32.255423659435124,
        tier5: 19.0749079001228,
        tier6: 12.68931641424478,
        tier7: 3.643061809250921
    },
    {
        role: "Data Analysis & BI",
        exp: "0-0",
        tier1: 20.32967032967033,
        tier2: 42.857142857142854,
        tier3: 18.13186813186813,
        tier4: 7.6923076923076925,
        tier5: 5.4945054945054945,
        tier6: 3.296703296703297,
        tier7: 2.197802197802198
    },
    {
        role: "Data Analysis & BI",
        exp: "10-",
        tier1: 0.6211180124223602,
        tier2: 2.7950310559006213,
        tier3: 14.906832298136646,
        tier4: 29.503105590062113,
        tier5: 22.049689440993788,
        tier6: 22.36024844720497,
        tier7: 7.453416149068323
    },
    {
        role: "Data Analysis & BI",
        exp: "2-5",
        tier1: 2.0172910662824206,
        tier2: 19.88472622478386,
        tier3: 33.429394812680115,
        tier4: 26.801152737752158,
        tier5: 12.103746397694524,
        tier6: 3.170028818443804,
        tier7: 2.5936599423631126
    },
    {
        role: "Data Analysis & BI",
        exp: "5-10",
        tier1: 0.4444444444444444,
        tier2: 7.555555555555555,
        tier3: 23.555555555555554,
        tier4: 32.44444444444444,
        tier5: 23.11111111111111,
        tier6: 9.333333333333334,
        tier7: 3.5555555555555554
    },
    {
        role: "Data Analysis & BI",
        exp: "-2",
        tier1: 12.411347517730496,
        tier2: 52.4822695035461,
        tier3: 25.886524822695034,
        tier4: 5.319148936170213,
        tier5: 1.773049645390071,
        tier6: 0.7092198581560284,
        tier7: 0.7092198581560284
    },
    {
        role: "Data Engineer",
        exp: "0-0",
        tier1: 20.535714285714285,
        tier2: 36.607142857142854,
        tier3: 23.214285714285715,
        tier4: 7.142857142857142,
        tier5: 4.464285714285714,
        tier6: 3.571428571428571,
        tier7: 3.571428571428571
    },
    {
        role: "Data Engineer",
        exp: "10-",
        tier1: 0.3134796238244514,
        tier2: 2.8213166144200628,
        tier3: 8.463949843260188,
        tier4: 21.630094043887148,
        tier5: 20.06269592476489,
        tier6: 32.288401253918494,
        tier7: 14.106583072100314
    },
    {
        role: "Data Engineer",
        exp: "-2",
        tier1: 7.964601769911504,
        tier2: 41.5929203539823,
        tier3: 38.49557522123894,
        tier4: 6.1946902654867255,
        tier5: 2.2123893805309733,
        tier6: 0.8849557522123894,
        tier7: 2.212389380530974
    },
    {
        role: "Data Engineer",
        exp: "2-5",
        tier1: 1.5544041450777202,
        tier2: 12.694300518134716,
        tier3: 31.865284974093267,
        tier4: 25.906735751295333,
        tier5: 17.616580310880828,
        tier6: 8.290155440414509,
        tier7: 1.8134715025906738
    },
    {
        role: "Data Engineer",
        exp: "5-10",
        tier1: 1.094890510948905,
        tier2: 2.18978102189781,
        tier3: 11.678832116788321,
        tier4: 24.817518248175183,
        tier5: 30.29197080291971,
        tier6: 21.897810218978105,
        tier7: 8.02919708029197
    },
    {
        role: "Data Scientist",
        exp: "10-",
        tier1: 0.4629629629629629,
        tier2: 3.2407407407407405,
        tier3: 7.87037037037037,
        tier4: 25.925925925925924,
        tier5: 20.833333333333336,
        tier6: 25,
        tier7: 15.74074074074074
    },
    {
        role: "Data Scientist",
        exp: "2-5",
        tier1: 1.1990407673860912,
        tier2: 15.347721822541965,
        tier3: 30.69544364508393,
        tier4: 27.098321342925658,
        tier5: 16.546762589928058,
        tier6: 6.71462829736211,
        tier7: 2.1582733812949644
    },
    {
        role: "Data Scientist",
        exp: "5-10",
        tier1: 1.2987012987012987,
        tier2: 5.194805194805195,
        tier3: 15.584415584415584,
        tier4: 25.108225108225106,
        tier5: 30.303030303030305,
        tier6: 15.151515151515152,
        tier7: 7.359307359307359
    },
    {
        role: "Data Scientist",
        exp: "0-0",
        tier1: 19.393939393939394,
        tier2: 40,
        tier3: 24.242424242424242,
        tier4: 9.090909090909092,
        tier5: 3.6363636363636362,
        tier6: 1.8181818181818181,
        tier7: 1.2121212121212122
    },
    {
        role: "Data Scientist",
        exp: "-2",
        tier1: 9.49367088607595,
        tier2: 48.41772151898734,
        tier3: 28.48101265822785,
        tier4: 8.227848101265822,
        tier5: 2.848101265822785,
        tier6: 0.949367088607595,
        tier7: 1.2658227848101267
    },
    {
        role: "DevOps & Infra. & SRE",
        exp: "0-0",
        tier1: 18.556701030927837,
        tier2: 29.896907216494846,
        tier3: 9.278350515463918,
        tier4: 9.278350515463918,
        tier5: 15.463917525773196,
        tier6: 11.34020618556701,
        tier7: 6.185567010309278
    },
    {
        role: "DevOps & Infra. & SRE",
        exp: "10-",
        tier1: 0,
        tier2: 2.857142857142857,
        tier3: 8.181818181818182,
        tier4: 21.948051948051948,
        tier5: 23.376623376623375,
        tier6: 28.96103896103896,
        tier7: 14.545454545454545
    },
    {
        role: "DevOps & Infra. & SRE",
        exp: "2-5",
        tier1: 2.9484029484029484,
        tier2: 13.513513513513514,
        tier3: 28.746928746928745,
        tier4: 27.27272727272727,
        tier5: 16.953316953316953,
        tier6: 7.616707616707617,
        tier7: 2.9484029484029484
    },
    {
        role: "DevOps & Infra. & SRE",
        exp: "5-10",
        tier1: 0.6048387096774194,
        tier2: 3.8306451612903225,
        tier3: 15.32258064516129,
        tier4: 25.806451612903224,
        tier5: 23.18548387096774,
        tier6: 23.991935483870968,
        tier7: 7.056451612903226
    },
    {
        role: "DevOps & Infra. & SRE",
        exp: "-2",
        tier1: 10.526315789473683,
        tier2: 52.63157894736842,
        tier3: 22.966507177033492,
        tier4: 10.047846889952153,
        tier5: 1.4354066985645932,
        tier6: 1.4354066985645932,
        tier7: 0.4784688995215311
    },
    {
        role: "Engineering Management",
        exp: "0-0",
        tier1: 11.363636363636363,
        tier2: 13.636363636363635,
        tier3: 9.090909090909092,
        tier4: 15.909090909090908,
        tier5: 15.909090909090908,
        tier6: 15.909090909090908,
        tier7: 15.909090909090908
    },
    {
        role: "Engineering Management",
        exp: "10-",
        tier1: 0.1128668171557562,
        tier2: 0.6772009029345373,
        tier3: 3.724604966139955,
        tier4: 12.302483069977427,
        tier5: 19.63882618510158,
        tier6: 36.681715575620764,
        tier7: 26.410835214446955
    },
    {
        role: "Engineering Management",
        exp: "2-5",
        tier1: 2.8301886792452833,
        tier2: 11.320754716981133,
        tier3: 26.41509433962264,
        tier4: 24.528301886792452,
        tier5: 23.58490566037736,
        tier6: 7.547169811320755,
        tier7: 3.7735849056603774
    },
    {
        role: "Engineering Management",
        exp: "5-10",
        tier1: 0,
        tier2: 1.3468013468013467,
        tier3: 10.1010101010101,
        tier4: 17.50841750841751,
        tier5: 26.936026936026934,
        tier6: 26.936026936026934,
        tier7: 16.835016835016834
    },
    {
        role: "Engineering Management",
        exp: "-2",
        tier1: 8.823529411764707,
        tier2: 38.23529411764706,
        tier3: 20.588235294117645,
        tier4: 14.705882352941178,
        tier5: 11.76470588235294,
        tier6: 0,
        tier7: 2.941176470588235
    },
    {
        role: "Frontend Developer",
        exp: "0-0",
        tier1: 31.29432624113475,
        tier2: 53.28014184397163,
        tier3: 7.624113475177305,
        tier4: 2.925531914893617,
        tier5: 2.039007092198582,
        tier6: 1.2411347517730498,
        tier7: 1.2411347517730498
    },
    {
        role: "Frontend Developer",
        exp: "10-",
        tier1: 0.7832898172323759,
        tier2: 5.047867711053089,
        tier3: 19.321148825065272,
        tier4: 30.374238468233244,
        tier5: 21.23585726718886,
        tier6: 17.667536988685814,
        tier7: 5.395996518711923
    },
    {
        role: "Frontend Developer",
        exp: "-2",
        tier1: 24.365256124721604,
        tier2: 59.10913140311804,
        tier3: 12.605790645879733,
        tier4: 2.271714922048998,
        tier5: 0.5345211581291759,
        tier6: 0.7572383073496659,
        tier7: 0.17817371937639198
    },
    {
        role: "Frontend Developer",
        exp: "2-5",
        tier1: 4.910509407985315,
        tier2: 28.54520422212024,
        tier3: 39.375860486461676,
        tier4: 17.622762735199633,
        tier5: 6.287287746672786,
        tier6: 2.2946305644791187,
        tier7: 0.8260670032124828
    },
    {
        role: "Frontend Developer",
        exp: "5-10",
        tier1: 1.1896893588896233,
        tier2: 7.865168539325842,
        tier3: 26.834104428288168,
        tier4: 30.138797091870455,
        tier5: 17.97752808988764,
        tier6: 12.425644415069398,
        tier7: 3.4368803701255786
    },
    {
        role: "Full-stack Developer",
        exp: "0-0",
        tier1: 26.53288740245262,
        tier2: 55.18394648829431,
        tier3: 8.695652173913043,
        tier4: 4.3478260869565215,
        tier5: 1.89520624303233,
        tier6: 2.118171683389075,
        tier7: 1.1148272017837235
    },
    {
        role: "Full-stack Developer",
        exp: "10-",
        tier1: 0.4194128220491312,
        tier2: 3.59496704613541,
        tier3: 16.117435590173756,
        tier4: 30.437387657279807,
        tier5: 22.768124625524266,
        tier6: 19.952067106051526,
        tier7: 6.411024565608148
    },
    {
        role: "Full-stack Developer",
        exp: "-2",
        tier1: 19.729307652264445,
        tier2: 60.3331598125976,
        tier3: 15.668922436231131,
        tier4: 2.6028110359187924,
        tier5: 0.4685059864653826,
        tier6: 0.8328995314940135,
        tier7: 0.20822488287350338
    },
    {
        role: "Full-stack Developer",
        exp: "2-5",
        tier1: 4.240447343895619,
        tier2: 24.79030754892824,
        tier3: 39.60857409133271,
        tier4: 19.757688723205966,
        tier5: 7.409133271202236,
        tier6: 2.9356943150046595,
        tier7: 1.1183597390493942
    },
    {
        role: "Full-stack Developer",
        exp: "5-10",
        tier1: 0.8561643835616438,
        tier2: 6.449771689497717,
        tier3: 26.71232876712329,
        tier4: 32.47716894977169,
        tier5: 17.751141552511417,
        tier6: 12.442922374429223,
        tier7: 3.2534246575342465
    },
    {
        role: "Mobile Developer",
        exp: "0-0",
        tier1: 36,
        tier2: 42.66666666666667,
        tier3: 8,
        tier4: 6,
        tier5: 4,
        tier6: 1.3333333333333335,
        tier7: 2
    },
    {
        role: "Mobile Developer",
        exp: "10-",
        tier1: 0.29239766081871343,
        tier2: 2.046783625730994,
        tier3: 15.789473684210526,
        tier4: 27.192982456140353,
        tier5: 25.730994152046783,
        tier6: 20.760233918128655,
        tier7: 7.894736842105263
    },
    {
        role: "Mobile Developer",
        exp: "2-5",
        tier1: 4.326923076923077,
        tier2: 21.153846153846153,
        tier3: 35.33653846153847,
        tier4: 23.798076923076923,
        tier5: 8.89423076923077,
        tier6: 4.807692307692308,
        tier7: 1.6826923076923077
    },
    {
        role: "Mobile Developer",
        exp: "5-10",
        tier1: 1.3729977116704806,
        tier2: 4.576659038901601,
        tier3: 22.19679633867277,
        tier4: 27.91762013729977,
        tier5: 21.052631578947366,
        tier6: 18.306636155606405,
        tier7: 4.118993135011442
    },
    {
        role: "Mobile Developer",
        exp: "-2",
        tier1: 24.556213017751478,
        tier2: 56.80473372781065,
        tier3: 14.201183431952662,
        tier4: 2.6627218934911245,
        tier5: 0.591715976331361,
        tier6: 1.183431952662722,
        tier7: 0
    },
    {
        role: "Product Design (UI/UX)",
        exp: "2-5",
        tier1: 2.1671826625387,
        tier2: 41.17647058823529,
        tier3: 39.628482972136226,
        tier4: 12.38390092879257,
        tier5: 2.786377708978328,
        tier6: 0.9287925696594427,
        tier7: 0.9287925696594428
    },
    {
        role: "Product Design (UI/UX)",
        exp: "0-0",
        tier1: 16.666666666666664,
        tier2: 55.26315789473685,
        tier3: 16.666666666666664,
        tier4: 5.263157894736842,
        tier5: 1.7543859649122806,
        tier6: 1.7543859649122806,
        tier7: 2.631578947368421
    },
    {
        role: "Product Design (UI/UX)",
        exp: "-2",
        tier1: 17.338709677419356,
        tier2: 62.5,
        tier3: 16.129032258064516,
        tier4: 2.82258064516129,
        tier5: 0,
        tier6: 0.4032258064516129,
        tier7: 0.4032258064516129
    },
    {
        role: "Product Design (UI/UX)",
        exp: "10-",
        tier1: 1.1152416356877324,
        tier2: 13.011152416356877,
        tier3: 32.342007434944236,
        tier4: 28.624535315985128,
        tier5: 15.241635687732341,
        tier6: 7.434944237918216,
        tier7: 2.2304832713754648
    },
    {
        role: "Product Design (UI/UX)",
        exp: "5-10",
        tier1: 0.38461538461538464,
        tier2: 18.461538461538463,
        tier3: 38.07692307692307,
        tier4: 27.307692307692307,
        tier5: 10.384615384615385,
        tier6: 3.8461538461538463,
        tier7: 1.5384615384615385
    },
    {
        role: "Product Manager",
        exp: "0-0",
        tier1: 0,
        tier2: 15.789473684210526,
        tier3: 21.052631578947366,
        tier4: 21.052631578947366,
        tier5: 22.807017543859647,
        tier6: 7.017543859649122,
        tier7: 12.280701754385964
    },
    {
        role: "Product Manager",
        exp: "10-",
        tier1: 0.1949317738791423,
        tier2: 1.1695906432748537,
        tier3: 7.602339181286549,
        tier4: 20.857699805068226,
        tier5: 24.561403508771928,
        tier6: 33.91812865497076,
        tier7: 11.695906432748536
    },
    {
        role: "Product Manager",
        exp: "2-5",
        tier1: 0.3448275862068966,
        tier2: 12.068965517241379,
        tier3: 28.965517241379313,
        tier4: 29.310344827586203,
        tier5: 18.620689655172416,
        tier6: 7.586206896551724,
        tier7: 3.103448275862069
    },
    {
        role: "Product Manager",
        exp: "5-10",
        tier1: 0,
        tier2: 3.361344537815126,
        tier3: 14.565826330532214,
        tier4: 36.134453781512605,
        tier5: 21.84873949579832,
        tier6: 18.487394957983195,
        tier7: 5.602240896358543
    },
    {
        role: "Product Manager",
        exp: "-2",
        tier1: 3.278688524590164,
        tier2: 44.26229508196721,
        tier3: 31.147540983606557,
        tier4: 14.754098360655737,
        tier5: 4.918032786885246,
        tier6: 0,
        tier7: 1.639344262295082
    },
    {
        role: "Project & Delivery Manager",
        exp: "10-",
        tier1: 0,
        tier2: 1.864406779661017,
        tier3: 8.64406779661017,
        tier4: 22.966101694915253,
        tier5: 27.033898305084747,
        tier6: 32.45762711864407,
        tier7: 6.9491525423728815
    },
    {
        role: "Project & Delivery Manager",
        exp: "2-5",
        tier1: 0.9036144578313252,
        tier2: 28.313253012048197,
        tier3: 33.433734939759034,
        tier4: 31.32530120481928,
        tier5: 13.855421686746988,
        tier6: 5.120481927710843,
        tier7: 1.2048192771084338
    },
    {
        role: "Project & Delivery Manager",
        exp: "5-10",
        tier1: 0.3952569169960474,
        tier2: 6.126482213438735,
        tier3: 20.35573122529644,
        tier4: 33.794466403162055,
        tier5: 19.76284584980237,
        tier6: 16.40316205533597,
        tier7: 3.162055335968379
    },
    {
        role: "Project & Delivery Manager",
        exp: "0-0",
        tier1: 3.75,
        tier2: 26.25,
        tier3: 22.5,
        tier4: 18.75,
        tier5: 16.25,
        tier6: 8.75,
        tier7: 3.75
    },
    {
        role: "Project & Delivery Manager",
        exp: "-2",
        tier1: 1.2195121951219512,
        tier2: 60.97560975609756,
        tier3: 28.04878048780488,
        tier4: 6.097560975609756,
        tier5: 3.6585365853658534,
        tier6: 0,
        tier7: 0
    },
    {
        role: "QA & Testing Engineer",
        exp: "10-",
        tier1: 1.092896174863388,
        tier2: 5.46448087431694,
        tier3: 16.939890710382514,
        tier4: 30.05464480874317,
        tier5: 25.136612021857925,
        tier6: 17.48633879781421,
        tier7: 3.825136612021858
    },
    {
        role: "QA & Testing Engineer",
        exp: "2-5",
        tier1: 3.524229074889868,
        tier2: 26.87224669603524,
        tier3: 41.409691629955944,
        tier4: 16.299559471365637,
        tier5: 7.488986784140969,
        tier6: 1.3215859030837005,
        tier7: 2.643171806167401
    },
    {
        role: "QA & Testing Engineer",
        exp: "5-10",
        tier1: 1.1560693641618496,
        tier2: 15.028901734104046,
        tier3: 27.167630057803464,
        tier4: 21.965317919075144,
        tier5: 21.38728323699422,
        tier6: 10.404624277456648,
        tier7: 2.312138728323699
    },
    {
        role: "QA & Testing Engineer",
        exp: "0-0",
        tier1: 23.456790123456788,
        tier2: 53.086419753086425,
        tier3: 12.345679012345679,
        tier4: 3.7037037037037033,
        tier5: 3.7037037037037033,
        tier6: 1.2345679012345678,
        tier7: 1.2345679012345678
    },
    {
        role: "QA & Testing Engineer",
        exp: "-2",
        tier1: 20.26143790849673,
        tier2: 54.90196078431373,
        tier3: 16.99346405228758,
        tier4: 5.88235294117647,
        tier5: 1.3071895424836601,
        tier6: 0,
        tier7: 0
    },
    {
        role: "Software Architect",
        exp: "0-0",
        tier1: 15.18987341772152,
        tier2: 18.9873417721519,
        tier3: 12.658227848101266,
        tier4: 11.39240506329114,
        tier5: 10.126582278481013,
        tier6: 24.050632911392405,
        tier7: 7.594936708860759
    },
    {
        role: "Software Architect",
        exp: "10-",
        tier1: 0.11148272017837235,
        tier2: 1.1148272017837235,
        tier3: 3.2329988851727984,
        tier4: 18.61761426978818,
        tier5: 27.201783723522855,
        tier6: 31.995540691192865,
        tier7: 17.16833890746934
    },
    {
        role: "Software Architect",
        exp: "2-5",
        tier1: 3.4220532319391634,
        tier2: 11.787072243346007,
        tier3: 27.756653992395435,
        tier4: 29.277566539923956,
        tier5: 16.34980988593156,
        tier6: 6.844106463878327,
        tier7: 4.182509505703422
    },
    {
        role: "Software Architect",
        exp: "5-10",
        tier1: 0,
        tier2: 1.5350877192982455,
        tier3: 6.578947368421052,
        tier4: 25,
        tier5: 28.947368421052634,
        tier6: 25.219298245614034,
        tier7: 12.280701754385964
    },
    {
        role: "Software Architect",
        exp: "-2",
        tier1: 15.517241379310345,
        tier2: 39.6551724137931,
        tier3: 33.62068965517241,
        tier4: 6.896551724137931,
        tier5: 2.586206896551724,
        tier6: 0.8620689655172413,
        tier7: 0
    },
    {
        role: "SysAdmin",
        exp: "0-0",
        tier1: 23.52941176470588,
        tier2: 37.254901960784316,
        tier3: 9.803921568627452,
        tier4: 11.76470588235294,
        tier5: 11.76470588235294,
        tier6: 1.9607843137254901,
        tier7: 3.9215686274509802
    },
    {
        role: "SysAdmin",
        exp: "10-",
        tier1: 1.1494252873563218,
        tier2: 8.333333333333332,
        tier3: 26.72413793103448,
        tier4: 25.862068965517242,
        tier5: 20.114942528735632,
        tier6: 13.218390804597702,
        tier7: 4.310344827586206
    },
    {
        role: "SysAdmin",
        exp: "2-5",
        tier1: 1.7857142857142856,
        tier2: 30.357142857142854,
        tier3: 39.88095238095239,
        tier4: 18.452380952380953,
        tier5: 7.142857142857142,
        tier6: 1.7857142857142856,
        tier7: 0.5952380952380952
    },
    {
        role: "SysAdmin",
        exp: "5-10",
        tier1: 1.5789473684210527,
        tier2: 20,
        tier3: 30.526315789473685,
        tier4: 22.63157894736842,
        tier5: 13.684210526315791,
        tier6: 7.894736842105263,
        tier7: 3.6842105263157894
    },
    {
        role: "SysAdmin",
        exp: "-2",
        tier1: 15.11627906976744,
        tier2: 56.97674418604651,
        tier3: 19.767441860465116,
        tier4: 4.651162790697675,
        tier5: 0,
        tier6: 2.3255813953488373,
        tier7: 0
    },
    {
        role: "Tech Lead",
        exp: "0-0",
        tier1: 3.1746031746031744,
        tier2: 6.349206349206349,
        tier3: 7.936507936507936,
        tier4: 23.809523809523807,
        tier5: 12.698412698412698,
        tier6: 28.57142857142857,
        tier7: 17.46031746031746
    },
    {
        role: "Tech Lead",
        exp: "10-",
        tier1: 0.21994134897360706,
        tier2: 0.5131964809384164,
        tier3: 4.618768328445748,
        tier4: 17.082111436950147,
        tier5: 25.806451612903224,
        tier6: 33.94428152492669,
        tier7: 17.44868035190616
    },
    {
        role: "Tech Lead",
        exp: "2-5",
        tier1: 3.292181069958848,
        tier2: 3.7037037037037033,
        tier3: 20.5761316872428,
        tier4: 31.275720164609055,
        tier5: 24.691358024691358,
        tier6: 11.11111111111111,
        tier7: 5.349794238683128
    },
    {
        role: "Tech Lead",
        exp: "5-10",
        tier1: 0.1287001287001287,
        tier2: 1.1583011583011582,
        tier3: 8.622908622908623,
        tier4: 24.967824967824967,
        tier5: 25.225225225225223,
        tier6: 28.57142857142857,
        tier7: 11.068211068211067
    },
    {
        role: "Tech Lead",
        exp: "-2",
        tier1: 3.4482758620689653,
        tier2: 24.137931034482758,
        tier3: 41.37931034482759,
        tier4: 13.793103448275861,
        tier5: 3.4482758620689653,
        tier6: 6.896551724137931,
        tier7: 3.4482758620689653
    }
];
var AVERAGESALARYBYENGLISHLEVEL = function(t) {
    return [
        {
            level: t("mandecar23.benefits.english.basic"),
            tier1: 17.322432294328053,
            tier2: 27.491057741440983,
            tier3: 20.0817577925396,
            tier4: 17.322432294328053,
            tier5: 7.153806847215124,
            tier6: 4.496678589678078,
            tier7: 2.1972406745017885
        },
        {
            level: t("mandecar23.benefits.english.intermediate"),
            tier1: 11.227839789888378,
            tier2: 23.5281243160429,
            tier3: 19.43532501641497,
            tier4: 19.107025607353904,
            tier5: 12.103304880717882,
            tier6: 7.7040927992996275,
            tier7: 3.2173342087984245
        },
        {
            level: t("mandecar23.benefits.english.fluent"),
            tier1: 5.757696921231507,
            tier2: 17.712914834066375,
            tier3: 17.293082766893242,
            tier4: 16.11355457816873,
            tier5: 13.894442223110756,
            tier6: 14.814074370251898,
            tier7: 11.175529788084765
        },
        {
            level: t("mandecar23.benefits.english.native"),
            tier1: 5.061349693251533,
            tier2: 16.411042944785276,
            tier3: 14.877300613496933,
            tier4: 11.65644171779141,
            tier5: 10.276073619631902,
            tier6: 13.496932515337424,
            tier7: 21.319018404907975
        }
    ];
};
var AVERAGESALARYBYROLEANDEXPERIENCETABS = function(t) {
    return {
        label: t("mandecar23.benefits.average-salary-role.experience"),
        tabsName: "averageSalaryByRoleAndExperience",
        tabs: [
            {
                id: "exp-2",
                label: "<2 " + t("mandecar23.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "-2"
                })
            },
            {
                id: "exp2-5",
                label: "2-5 " + t("mandecar23.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "2-5"
                })
            },
            {
                id: "exp5-10",
                label: "5-10 " + t("mandecar23.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "5-10"
                })
            },
            {
                id: "exp+10",
                label: ">10 " + t("mandecar23.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "10-"
                }),
                defaultChecked: true
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/AverageSalaryByEnglishLevel.tsx





var AverageSalaryByEnglishLevel = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var averageSalaryByEnglishLevel = AVERAGESALARYBYENGLISHLEVEL(t);
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "<20K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€20-30K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€31-40K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€41-50K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€51-60K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€61-80K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: ">80K"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: averageSalaryByEnglishLevel.map(function(data, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: data.level
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier1),
                                            children: [
                                                data.tier1.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier2),
                                            children: [
                                                data.tier2.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier3),
                                            children: [
                                                data.tier3.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier4),
                                            children: [
                                                data.tier4.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier5),
                                            children: [
                                                data.tier5.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier6),
                                            children: [
                                                data.tier6.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(data.tier7),
                                            children: [
                                                data.tier7.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var benefits_AverageSalaryByEnglishLevel = (AverageSalaryByEnglishLevel);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/Benefits.styled.tsx

function Benefits_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    Benefits_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83914244-0"
})(Benefits_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xs2"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/LocationPreference.styled.tsx

function LocationPreference_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  gap: ",
        ";\n  text-align: center;\n  margin: 0;\n  transition: 0.3s;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: ",
        ";\n\n  &:hover ",
        " {\n    opacity: 0.5;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n    align-items: flex-end;\n    max-width: min-content;\n  }\n"
    ]);
    LocationPreference_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.25;\n  white-space: nowrap;\n"
    ]);
    LocationPreference_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  &.big {\n    width: 13.75rem;\n    height: 13.75rem;\n    background-color: ",
        ";\n  }\n\n  &.medium {\n    width: 9.125rem;\n    height: 9.125rem;\n    background-color: ",
        ";\n  }\n\n  &.small {\n    width: 6.875rem;\n    height: 6.875rem;\n    background-color: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        ";\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  img {\n    max-width: 15.5rem;\n    border-radius: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n\n  p {\n    margin-top: 0;\n  }\n"
    ]);
    LocationPreference_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledItem = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-bfa02d0d-0"
})(LocationPreference_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfa02d0d-1"
})(LocationPreference_styled_templateObject1(), (0,theme/* spacing */.W0)("xl2"), StyledItem, (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-bfa02d0d-2"
})(LocationPreference_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("medium"));
var LocationPreference_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfa02d0d-3"
})(LocationPreference_styled_templateObject3(), (0,theme/* radius */.q0)("full"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_06"), (0,theme/* color */.$_)("ylgnbu_04"));
var LocationPreference_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfa02d0d-4"
})(LocationPreference_styled_templateObject4(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("lg"));
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfa02d0d-5"
})(LocationPreference_styled_templateObject5());

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/LocationPreference.tsx







var LocationPreference = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locationData = LOCATIONDATA(t).sort(function(a, b) {
        return a.value > b.value ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
                children: locationData.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationPreference_styled_StyledValue, {
                                className: item.type,
                                children: [
                                    item.value.toFixed(1),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                                children: item.label
                            })
                        ]
                    }, item.type);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationPreference_styled_StyledSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/location.gif"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2023",
                            i18nKey: "mandecar23.benefits.location.text"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var benefits_LocationPreference = (LocationPreference);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/benefits/Benefits.tsx










var Benefits = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var heroData = HERODATA(t);
    var averageSalaryTabs = AVERAGESALARYTABS(t);
    var averageSalaryByRoleAndExperienceTabs = AVERAGESALARYBYROLEANDEXPERIENCETABS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                background: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/benefits-hero-bg.webp"),
                backgroundSm: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/benefits-hero-bg-sm.webp"),
                title: t("mandecar23.benefits.hero.title"),
                desc: t("mandecar23.benefits.hero.desc"),
                data: heroData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.benefits.location.title"),
                desc: t("mandecar23.benefits.location.desc"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_LocationPreference, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.benefits.average-salary-language.title"),
                desc: t("mandecar23.benefits.average-salary-language.desc"),
                descExtra: t("mandecar23.benefits.average-salary-language.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: averageSalaryTabs.tabsName,
                    tabs: averageSalaryTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.benefits.average-salary-role.title"),
                desc: t("mandecar23.benefits.average-salary-role.desc"),
                descExtra: t("mandecar23.benefits.average-salary-role.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: averageSalaryByRoleAndExperienceTabs.tabsName,
                    tabs: averageSalaryByRoleAndExperienceTabs.tabs,
                    label: averageSalaryByRoleAndExperienceTabs.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.benefits.english.title"),
                desc: t("mandecar23.benefits.english.desc"),
                descExtra: t("mandecar23.benefits.english.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByEnglishLevel, {})
            })
        ]
    });
};
/* harmony default export */ var benefits_Benefits = (Benefits);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(80739);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(24908);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/Companies.constants.tsx
var Companies_constants_HERODATA = function(t) {
    return [
        {
            value: "34%",
            desc: t("mandecar23.companies.hero.key-point-1")
        },
        {
            value: "32%",
            desc: t("mandecar23.companies.hero.key-point-2")
        },
        {
            value: "85%",
            desc: t("mandecar23.companies.hero.key-point-3")
        },
        {
            value: "13%",
            desc: t("mandecar23.companies.hero.key-point-4")
        }
    ];
};
var SALARYOFFEREDVSWANTED = [
    {
        role: "Backend Developer",
        manfredite: 42.08866770157976,
        offer: 45.27777777777778
    },
    {
        role: "Data Analysis & BI",
        manfredite: 42.338007380073805,
        offer: 48.6875
    },
    {
        role: "Data Engineer",
        manfredite: 48.58155487804878,
        offer: 50.94827586206896
    },
    {
        role: "Data Scientist",
        manfredite: 44.12593144560358,
        offer: 56.666666666666664
    },
    {
        role: "DevOps & Infra. & SRE",
        manfredite: 52.25455465587044,
        offer: 48.36486486486487
    },
    {
        role: "Engineering Management",
        manfredite: 66.12371888726207,
        offer: 55.27777777777778
    },
    {
        role: "Frontend Developer",
        manfredite: 36.71053915589168,
        offer: 41.44017094017094
    },
    {
        role: "Full-stack Developer",
        manfredite: 39.66630837214858,
        offer: 41.75925925925926
    },
    {
        role: "Mobile Developer",
        manfredite: 42.381547619047616,
        offer: 45.354838709677416
    },
    {
        role: "Product Design (UI/UX)",
        manfredite: 35.79018961253092,
        offer: 42.5
    },
    {
        role: "Product Manager",
        manfredite: 53.84952978056426,
        offer: 51.25
    },
    {
        role: "Project & Delivery Manager",
        manfredite: 52.51606978879706,
        offer: 45.25
    },
    {
        role: "QA & Testing Engineer",
        manfredite: 40.28527607361963,
        offer: 37.85
    },
    {
        role: "Software Architect",
        manfredite: 58.591287458379576,
        offer: 53.57142857142857
    },
    {
        role: "SysAdmin",
        manfredite: 42.397146254458974,
        offer: 36.5
    },
    {
        role: "Tech Lead",
        manfredite: 61.892105263157895,
        offer: 52.05
    }
];
var MOSTWANTEDROLES = function(locale) {
    return [
        {
            role: "Backend Developer",
            value: 34.32835820895522,
            fill: "#08306B"
        },
        {
            role: "Frontend Developer",
            value: 19.402985074626866,
            fill: "#08306B"
        },
        {
            role: "DevOps & Infra. & SRE",
            value: 6.135986733001658,
            fill: "#08306B"
        },
        {
            role: "Mobile Developer",
            value: 5.140961857379768,
            fill: "#08519C"
        },
        {
            role: "QA & Testing Engineer",
            value: 4.975124378109453,
            fill: "#08519C"
        },
        {
            role: "Data Engineer",
            value: 4.809286898839138,
            fill: "#08519C"
        },
        {
            role: "Full-stack Developer",
            value: 4.477611940298507,
            fill: "#2171B5"
        },
        {
            role: "Tech Lead",
            value: 3.316749585406302,
            fill: "#2171B5"
        },
        {
            role: "Project & Delivery Manager",
            value: 1.658374792703151,
            fill: "#2171B5"
        },
        {
            role: "SysAdmin",
            value: 1.658374792703151,
            fill: "#4292C6"
        },
        {
            role: "Engineering Management",
            value: 1.4925373134328357,
            fill: "#4292C6"
        },
        {
            role: "Data Analysis & BI",
            value: 1.3266998341625207,
            fill: "#4292C6"
        },
        {
            role: "Software Architect",
            value: 1.1608623548922055,
            fill: "#6BAED6"
        },
        {
            role: "Product Design (UI/UX)",
            value: 1.1608623548922055,
            fill: "#6BAED6"
        },
        {
            role: "Product Manager",
            value: 0.6633499170812603,
            fill: "#6BAED6"
        },
        {
            role: "Data Scientist",
            value: 0.4975124378109453,
            fill: "#6BAED6"
        }
    ];
};
var MOSTOFFEREDPERKS = function(locale) {
    return [
        {
            perk: {
                en: "Dynamics and teambuilding events",
                es: "Din\xe1micas y eventos de teambuilding"
            },
            value: 11.917543482928924,
            fill: "#08306B"
        },
        {
            perk: {
                en: "Budget for training",
                es: "Presupuesto para formaci\xf3n"
            },
            value: 11.488082456517072,
            fill: "#08306B"
        },
        {
            perk: {
                en: "Internal training events",
                es: "Eventos de formaci\xf3n internos"
            },
            value: 9.233412067854841,
            fill: "#08519C"
        },
        {
            perk: {
                en: "Health insurance",
                es: "Seguro de salud"
            },
            value: 7.494094910886837,
            fill: "#08519C"
        },
        {
            perk: {
                en: "Possibility to choose your devices",
                es: "Posibilidad de elegir equipo"
            },
            value: 6.334550139574834,
            fill: "#2171B5"
        },
        {
            perk: {
                en: "Language classes",
                es: "Clases de Idiomas"
            },
            value: 6.248657934292463,
            fill: "#2171B5"
        },
        {
            perk: {
                en: "Budget for Conferences",
                es: "Presupuesto para Conferencias"
            },
            value: 6.119819626368907,
            fill: "#4292C6"
        },
        {
            perk: {
                en: "Extra holidays",
                es: "Vacaciones Extra"
            },
            value: 5.668885548636461,
            fill: "#4292C6"
        },
        {
            perk: {
                en: "Coffee, fruit and snacks",
                es: "Caf\xe9, fruta y snacks"
            },
            value: 5.260897573545201,
            fill: "#6BAED6"
        },
        {
            perk: {
                en: "Welcome pack",
                es: "Pack de bienvenida"
            },
            value: 5.003220957698089,
            fill: "#6BAED6"
        }
    ];
};
var LOCATIONOFFEREDDATA = function(t) {
    return [
        {
            type: "medium",
            value: 13.007159904534607,
            label: t("mandecar23.companies.locations-offered.hybrid")
        },
        {
            type: "big",
            value: 85.68019093078759,
            label: t("mandecar23.companies.locations-offered.remote")
        },
        {
            type: "small",
            value: 1.3126491646778042,
            label: t("mandecar23.companies.locations-offered.onsite")
        }
    ];
};

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/charts/MostOfferedPerks.tsx






var MostOfferedPerks = function() {
    var locale = (0,router.useRouter)().locale;
    var mostOfferedPerks = MOSTOFFEREDPERKS(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: mostOfferedPerks,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: function(data) {
                                    return data.perk[locale || "en"];
                                },
                                tickLine: false,
                                width: 300
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostOfferedPerks = (MostOfferedPerks);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/charts/MostWantedRoles.tsx






var MostWantedRoles = function() {
    var locale = (0,router.useRouter)().locale;
    var mostWantedRoles = MOSTWANTEDROLES(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 600,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: mostWantedRoles,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "role",
                                tickLine: false,
                                width: 240
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostWantedRoles = (MostWantedRoles);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/charts/SalaryOfferedVsWanted.tsx






var SalaryOfferedVsWanted = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var salaryOfferedVsWanted = SALARYOFFEREDVSWANTED.sort(function(a, b) {
        return a.offer > b.offer ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "xAxisLabel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 650,
                    width: "99%",
                    minWidth: 700,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: salaryOfferedVsWanted,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "category",
                                dataKey: "role",
                                tickLine: false,
                                interval: 0,
                                angle: -60,
                                textAnchor: "end",
                                height: 200,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                width: 60,
                                axisLine: false,
                                tickMargin: 5,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                padding: {
                                    bottom: 5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€".concat(value.toFixed(1), "K");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "offer",
                                barSize: 12,
                                radius: 5,
                                fill: "#8DD3C7",
                                name: t("mandecar23.companies.salary-offered-wanted.employers")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "manfredite",
                                barSize: 12,
                                radius: 5,
                                fill: "#7EAFD3",
                                name: t("mandecar23.companies.salary-offered-wanted.candidates")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_SalaryOfferedVsWanted = (SalaryOfferedVsWanted);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/Companies.styled.tsx

function Companies_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Companies_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Companies_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89722960-0"
})(Companies_styled_templateObject(), (0,theme/* color */.$_)("sand_100"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/LocationOffered.tsx







var LocationOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locationOfferedData = LOCATIONOFFEREDDATA(t).sort(function(a, b) {
        return a.value > b.value ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
                children: locationOfferedData.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationPreference_styled_StyledValue, {
                                className: item.type,
                                children: [
                                    item.value.toFixed(1),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                                children: item.label
                            })
                        ]
                    }, item.type);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationPreference_styled_StyledSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/location-offered.gif"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2023",
                            i18nKey: "mandecar23.companies.locations-offered.text"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var companies_LocationOffered = (LocationOffered);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/companies/Companies.tsx











var Companies = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var heroData = Companies_constants_HERODATA(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Companies_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                background: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/companies-hero-bg.webp"),
                backgroundSm: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/companies-hero-bg-sm.webp"),
                title: t("mandecar23.companies.hero.title"),
                desc: t("mandecar23.companies.hero.desc"),
                data: heroData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.companies.salary-offered-wanted.title"),
                desc: t("mandecar23.companies.salary-offered-wanted.desc"),
                descExtra: t("mandecar23.companies.salary-offered-wanted.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SalaryOfferedVsWanted, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.companies.most-wanted-roles.title"),
                desc: t("mandecar23.companies.most-wanted-roles.desc"),
                descExtra: t("mandecar23.companies.most-wanted-roles.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostWantedRoles, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.companies.most-offered-perks.title"),
                desc: t("mandecar23.companies.most-offered-perks.desc"),
                descExtra: t("mandecar23.companies.most-offered-perks.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostOfferedPerks, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.companies.locations-offered.title"),
                desc: t("mandecar23.companies.locations-offered.desc"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_LocationOffered, {})
            })
        ]
    });
};
/* harmony default export */ var companies_Companies = (Companies);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/Gender.constants.tsx
var Gender_constants_HERODATA = function(t) {
    return [
        {
            value: "46.5%",
            desc: t("mandecar23.gender.hero.key-point-1")
        },
        {
            value: "20%",
            desc: t("mandecar23.gender.hero.key-point-2")
        },
        {
            value: "4.5%",
            desc: t("mandecar23.gender.hero.key-point-3")
        },
        {
            value: "+10K",
            desc: t("mandecar23.gender.hero.key-point-4")
        }
    ];
};
var REPRESENTATIONDATA = function(t) {
    return [
        {
            value: t("mandecar23.gender.representation.product-design")
        },
        {
            value: t("mandecar23.gender.representation.product-management")
        },
        {
            value: t("mandecar23.gender.representation.testing")
        },
        {
            value: t("mandecar23.gender.representation.data-analysis")
        }
    ];
};
var GENDERBYROLE = [
    {
        role: "Software Architect",
        male: 95.15320334261838,
        female: 4.846796657381615
    },
    {
        role: "Data Engineer",
        male: 91.93302891933028,
        female: 8.06697108066971
    },
    {
        role: "Project & Delivery Manager",
        male: 78.89699179580674,
        female: 21.103008204193255
    },
    {
        role: "SysAdmin",
        male: 94.89311163895488,
        female: 5.10688836104513
    },
    {
        role: "Frontend Developer",
        male: 83.53099400904756,
        female: 16.46900599095244
    },
    {
        role: "DevOps & Infra. & SRE",
        male: 94.73150962512665,
        female: 5.268490374873354
    },
    {
        role: "Product Design (UI/UX)",
        male: 53.53946297803092,
        female: 46.46053702196908
    },
    {
        role: "Backend Developer",
        male: 90.82913421896473,
        female: 9.170865781035273
    },
    {
        role: "Full-stack Developer",
        male: 89.0555622224889,
        female: 10.9444377775111
    },
    {
        role: "Data Analysis & BI",
        male: 79.91137370753324,
        female: 20.088626292466767
    },
    {
        role: "QA & Testing Engineer",
        male: 75.4950495049505,
        female: 24.504950495049506
    },
    {
        role: "Tech Lead",
        male: 95.45085296506905,
        female: 4.54914703493095
    },
    {
        role: "Product Manager",
        male: 75.97809076682316,
        female: 24.02190923317684
    },
    {
        role: "Engineering Management",
        male: 93.23636363636363,
        female: 6.763636363636364
    },
    {
        role: "Data Scientist",
        male: 85.79925650557621,
        female: 14.200743494423792
    },
    {
        role: "Mobile Developer",
        male: 91.1044776119403,
        female: 8.895522388059701
    }
];
var GENDERSALARYBYROLE = [
    {
        role: "Backend Developer",
        male: 42.690946714950854,
        female: 35.83847736625515
    },
    {
        role: "Data Analysis & BI",
        male: 43.10796545105566,
        female: 39.60674157303371
    },
    {
        role: "Data Engineer",
        male: 48.724137931034484,
        female: 44.375
    },
    {
        role: "Data Scientist",
        male: 44.569882777276824,
        female: 40.66576086956522
    },
    {
        role: "DevOps & Infra. & SRE",
        male: 52.66135239142386,
        female: 44.275
    },
    {
        role: "Engineering Management",
        male: 66.90901771336554,
        female: 55.583333333333336
    },
    {
        role: "Frontend Developer",
        male: 37.78265121877821,
        female: 30.942012288786483
    },
    {
        role: "Full-stack Developer",
        male: 40.55297372060858,
        female: 32.314752252252255
    },
    {
        role: "Mobile Developer",
        male: 43.1684599865501,
        female: 35.10763888888889
    },
    {
        role: "Product Design (UI/UX)",
        male: 38.465299684542586,
        female: 32.772401433691755
    },
    {
        role: "Product Manager",
        male: 55.731374606505774,
        female: 47.85099337748344
    },
    {
        role: "Project & Delivery Manager",
        male: 54.465842167255595,
        female: 44.888520971302434
    },
    {
        role: "QA & Testing Engineer",
        male: 41.011804384485664,
        female: 37.47948717948718
    },
    {
        role: "Software Architect",
        male: 58.896021699819165,
        female: 52.877906976744185
    },
    {
        role: "SysAdmin",
        male: 42.550064184852374,
        female: 39.96511627906977
    },
    {
        role: "Tech Lead",
        male: 61.939321444106135,
        female: 57.25675675675676
    }
];
var GENDERSALARYBYROLEANDEXPERIENCE = [
    {
        role: "Backend Developer",
        tier4: {
            male: 55.19810201660736,
            female: 46.98701298701299
        },
        tier1: {
            male: 27.769024970273485,
            female: 26.962897526501767
        },
        tier2: {
            male: 38.75862794612795,
            female: 35.720408163265304
        },
        tier3: {
            male: 48.80599016540008,
            female: 47.86111111111111
        }
    },
    {
        role: "Full-stack Developer",
        tier4: {
            male: 54.56666666666666,
            female: 45.50595238095238
        },
        tier1: {
            male: 27.274016763378466,
            female: 26.405144694533764
        },
        tier2: {
            male: 38.09439608269859,
            female: 34.791666666666664
        },
        tier3: {
            male: 48.14869077306734,
            female: 44.43877551020408
        }
    },
    {
        role: "Frontend Developer",
        tier4: {
            male: 52.36410984848485,
            female: 43.36363636363636
        },
        tier1: {
            male: 26.676089517078914,
            female: 25.890396659707722
        },
        tier2: {
            male: 36.661512027491405,
            female: 34.365994236311245
        },
        tier3: {
            male: 48.076780415430264,
            female: 43.41880341880342
        }
    },
    {
        role: "Mobile Developer",
        tier4: {
            male: 56.36882716049383,
            female: 49.666666666666664
        },
        tier1: {
            male: 26.48148148148148,
            female: 26.090909090909093
        },
        tier2: {
            male: 39.85410764872521,
            female: 38.4
        },
        tier3: {
            male: 51.716748768472904,
            female: 47.891304347826086
        }
    },
    {
        role: "Software Architect",
        tier4: {
            male: 66.1820330969267,
            female: 56.027027027027025
        },
        tier1: {
            male: 30.4126213592233,
            female: 27.625
        },
        tier2: {
            male: 45.34334763948498,
            female: 49.63157894736842
        },
        tier3: {
            male: 60.44761904761904,
            female: 59.029411764705884
        }
    },
    {
        role: "DevOps & Infrastructure & SRE",
        tier4: {
            male: 61.81103448275862,
            female: 52.8235294117647
        },
        tier1: {
            male: 31.286885245901637,
            female: 30.416666666666668
        },
        tier2: {
            male: 44.46782841823057,
            female: 44.31818181818181
        },
        tier3: {
            male: 55.22222222222222,
            female: 50.473684210526315
        }
    },
    {
        role: "SysAdmin",
        tier4: {
            male: 49,
            female: 42.9
        },
        tier1: {
            male: 30.26875,
            female: 25.125
        },
        tier2: {
            male: 36.625,
            female: 36.208333333333336
        },
        tier3: {
            male: 43.28,
            female: 42.25
        }
    },
    {
        role: "Product Design (UI/UX)",
        tier4: {
            male: 45.3563829787234,
            female: 40.29113924050633
        },
        tier1: {
            male: 29.141509433962263,
            female: 26.248175182481752
        },
        tier2: {
            male: 33.875,
            female: 33.44886363636364
        },
        tier3: {
            male: 42.29936305732484,
            female: 37.94
        }
    },
    {
        role: "Product Manager",
        tier4: {
            male: 63.30656934306569,
            female: 55.01546391752578
        },
        tier1: {
            male: 32.34444444444445,
            female: 37
        },
        tier2: {
            male: 47.62041884816754,
            female: 40.90860215053763
        },
        tier3: {
            male: 54.49813432835821,
            female: 50.00588235294118
        }
    },
    {
        role: "Data Analysis & BI",
        tier4: {
            male: 56.58582089552239,
            female: 48.78
        },
        tier1: {
            male: 30.12200956937799,
            female: 32.525862068965516
        },
        tier2: {
            male: 41.45525291828794,
            female: 39.098684210526315
        },
        tier3: {
            male: 48.66571428571428,
            female: 44.576086956521735
        }
    },
    {
        role: "QA & Testing Engineer",
        tier4: {
            male: 52.9568345323741,
            female: 47.77906976744186
        },
        tier1: {
            male: 27.61764705882353,
            female: 31.62121212121212
        },
        tier2: {
            male: 38.85151515151515,
            female: 32.79
        },
        tier3: {
            male: 47.61693548387097,
            female: 42.05952380952381
        }
    },
    {
        role: "Project Manager & Delivery Manager",
        tier4: {
            male: 59.46821392532795,
            female: 53.86312849162011
        },
        tier1: {
            male: 30.99,
            female: 28.387096774193548
        },
        tier2: {
            male: 43.97945205479452,
            female: 38.10952380952381
        },
        tier3: {
            male: 51.599489795918366,
            female: 44.07943925233645
        }
    },
    {
        role: "Data Scientist",
        tier4: {
            male: 62.45744680851064,
            female: 52.44
        },
        tier1: {
            male: 31.55952380952381,
            female: 33.31111111111111
        },
        tier2: {
            male: 43.94883040935673,
            female: 40.80508474576271
        },
        tier3: {
            male: 53.0175,
            female: 49.392857142857146
        }
    },
    {
        role: "Data Engineer",
        tier4: {
            male: 62.960481099656356,
            female: 52.5625
        },
        tier1: {
            male: 33.03061224489796,
            female: 38.1764705882353
        },
        tier2: {
            male: 44.668181818181814,
            female: 38.833333333333336
        },
        tier3: {
            male: 55.182,
            female: 56.166666666666664
        }
    },
    {
        role: "Engineering Management",
        tier4: {
            male: 71.75272727272728,
            female: 60.39
        },
        tier1: {
            male: 35.766666666666666,
            female: 34.3524
        },
        tier2: {
            male: 46.39325842696629,
            female: 40.94444444444444
        },
        tier3: {
            male: 63.70229007633588,
            female: 51.130434782608695
        }
    },
    {
        role: "Tech Lead",
        tier4: {
            male: 65.87335398915569,
            female: 56.28431372549019
        },
        tier1: {
            male: 35.76086956521739,
            female: 28.3
        },
        tier2: {
            male: 49.4712389380531,
            female: 51.333333333333336
        },
        tier3: {
            male: 59.89817415730337,
            female: 56.58536585365854
        }
    }
];
var GENDERSALARYBYEXPERIENCE = [
    {
        exp: "<2y",
        male: 27.957399810665827,
        female: 27.24889135254989
    },
    {
        exp: "2-5y",
        male: 39.75275891341256,
        female: 35.66969972702457
    },
    {
        exp: "5-10y",
        male: 51.24115684093437,
        female: 44.286013986013984
    },
    {
        exp: ">10y",
        male: 59.706073371950154,
        female: 49.361420612813376
    }
];

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/charts/GenderByRole.tsx






var GenderByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var genderByRole = GENDERBYROLE.sort(function(a, b) {
        return a.female > b.female ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "gender gender-by-role",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 550,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: genderByRole,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                hide: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "role",
                                tickLine: false,
                                width: 210,
                                axisLine: false,
                                tickMargin: 10
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return value.toFixed(1) + "%";
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: -5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "female",
                                stackId: "a",
                                name: t("mandecar23.gender.females"),
                                barSize: 12,
                                radius: 5,
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "male",
                                stackId: "a",
                                name: t("mandecar23.gender.males"),
                                barSize: 12,
                                radius: 5,
                                fill: "#1B9D76"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_GenderByRole = (GenderByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/charts/GenderSalaryByExperience.tsx







var GenderSalaryByExperience = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "gender",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 450,
                    width: 500,
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: GENDERSALARYBYEXPERIENCE,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "category",
                                dataKey: "exp",
                                tickLine: false,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                width: 60,
                                axisLine: false,
                                tickMargin: 5,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                padding: {
                                    bottom: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#d9ceff"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€".concat(value.toFixed(1), "K");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: -5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "female",
                                name: t("mandecar23.gender.females"),
                                barSize: 12,
                                radius: 5,
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "male",
                                name: t("mandecar23.gender.males"),
                                barSize: 12,
                                radius: 5,
                                fill: "#1B9D76"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_GenderSalaryByExperience = (GenderSalaryByExperience);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/charts/GenderSalaryByRole.tsx







var GenderSalaryByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var genderSalaryByRole = GENDERSALARYBYROLE.sort(function(a, b) {
        return a.female > b.female ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "gender xAxisLabel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 650,
                    width: "99%",
                    minWidth: 700,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: genderSalaryByRole,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "category",
                                dataKey: "role",
                                tickLine: false,
                                interval: 0,
                                angle: -60,
                                textAnchor: "end",
                                height: 200,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                width: 60,
                                axisLine: false,
                                tickMargin: 5,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                padding: {
                                    bottom: 5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#d9ceff"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€".concat(value.toFixed(1), "K");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: -5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "female",
                                name: t("mandecar23.gender.females"),
                                barSize: 12,
                                radius: 5,
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "male",
                                name: t("mandecar23.gender.males"),
                                barSize: 12,
                                radius: 5,
                                fill: "#1B9D76"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_GenderSalaryByRole = (GenderSalaryByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/Gender.styled.tsx

function Gender_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    Gender_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Gender_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    Gender_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Gender_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    Gender_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Gender_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n"
    ]);
    Gender_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Gender_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  text-align: left;\n  border-radius: ",
        ";\n  color: ",
        ";\n\n  span {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n\n    &::before {\n      content: '';\n      width: ",
        ";\n      height: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    Gender_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Gender_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f864c24-0"
})(Gender_styled_templateObject(), (0,theme/* color */.$_)("indigo_100"), (0,theme/* spacing */.W0)("xs2"));
var StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f864c24-1"
})(Gender_styled_templateObject1(), (0,theme/* color */.$_)("indigo_500"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("text_white"));
var Gender_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f864c24-2"
})(Gender_styled_templateObject2(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var StyledList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f864c24-3"
})(Gender_styled_templateObject3(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"));
var Gender_styled_StyledItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f864c24-4"
})(Gender_styled_templateObject4(), (0,theme/* color */.$_)("indigo_100"), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("indigo_500"));

// EXTERNAL MODULE: ./components/shared/CustomSelect.tsx + 1 modules
var CustomSelect = __webpack_require__(88888);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/GenderCalculator.styled.tsx

function GenderCalculator_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  max-width: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 18rem;\n  align-self: center;\n"
    ]);
    GenderCalculator_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  color: ",
        ";\n"
    ]);
    GenderCalculator_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var GenderCalculator_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e00a4a7e-0"
})(GenderCalculator_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledInputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e00a4a7e-1"
})(GenderCalculator_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"));
var StyledOutputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e00a4a7e-2"
})(GenderCalculator_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("indigo_500"));
var StyledOutput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e00a4a7e-3"
})(GenderCalculator_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));
var StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e00a4a7e-4"
})(GenderCalculator_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"));
var GenderCalculator_styled_StyledValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e00a4a7e-5"
})(GenderCalculator_styled_templateObject5(), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl7"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/GenderCalculator.tsx







var GenderCalculator = function() {
    var ref = (0,react.useState)(), currentRole = ref[0], setCurrentRole = ref[1];
    var ref1 = (0,react.useState)(), currentYears = ref1[0], setCurrentYears = ref1[1];
    var ref2 = (0,react.useState)("--"), currentWomenSalary = ref2[0], setCurrentWomenSalary = ref2[1];
    var ref3 = (0,react.useState)("--"), currentMenSalary = ref3[0], setCurrentMenSalary = ref3[1];
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var ROLES = (0,react.useMemo)(function() {
        return GENDERSALARYBYROLEANDEXPERIENCE.map(function(param) {
            var role = param.role;
            return {
                label: role,
                value: role
            };
        });
    }, []);
    var YEARS = (0,react.useMemo)(function() {
        return [
            {
                label: "<2",
                value: "tier1"
            },
            {
                label: "2-5",
                value: "tier2"
            },
            {
                label: "5-10",
                value: "tier3"
            },
            {
                label: ">10",
                value: "tier4"
            }
        ];
    }, []);
    var handleRoleChange = function(param) {
        var value = param.value;
        setCurrentRole(value);
    };
    var handleYearsChange = function(param) {
        var value = param.value;
        setCurrentYears(value);
    };
    (0,react.useEffect)(function() {
        if (currentRole !== undefined && currentYears !== undefined) {
            var data = GENDERSALARYBYROLEANDEXPERIENCE.find(function(data) {
                return data.role === currentRole;
            });
            var _currentYears = data[currentYears], female = _currentYears.female, male = _currentYears.male;
            setCurrentMenSalary(male.toFixed(1));
            setCurrentWomenSalary(female.toFixed(1));
        } else {
            setCurrentMenSalary("--");
            setCurrentWomenSalary("--");
        }
    }, [
        currentRole,
        currentYears
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        label: t("mandecar23.gender.calculator.role"),
                        forId: "genderRole",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            defaultValue: GENDERSALARYBYROLE[0].role,
                            id: "genderRole",
                            isSmall: true,
                            onChange: handleRoleChange,
                            options: ROLES,
                            matchOrder: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        label: t("mandecar23.gender.calculator.years"),
                        forId: "genderRole",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            defaultValue: YEARS[0].value,
                            id: "genderExperience",
                            isSmall: true,
                            onChange: handleYearsChange,
                            options: YEARS,
                            matchOrder: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("mandecar23.gender.calculator.women")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentWomenSalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("mandecar23.gender.calculator.men")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentMenSalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var gender_GenderCalculator = (GenderCalculator);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/gender/Gender.tsx












var Gender = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var heroData = Gender_constants_HERODATA(t);
    var representationData = REPRESENTATIONDATA(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gender_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                background: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/gender-hero-bg.webp"),
                backgroundSm: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/gender-hero-bg-sm.webp"),
                title: t("mandecar23.gender.hero.title"),
                desc: t("mandecar23.gender.hero.desc"),
                data: heroData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.gender.gender-by-role.title"),
                desc: t("mandecar23.gender.gender-by-role.desc"),
                descExtra: t("mandecar23.gender.gender-by-role.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlight, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gender_styled_StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                            children: t("mandecar23.gender.representation.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                            children: representationData.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Gender_styled_StyledItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.value
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.gender.salary-by-gender.title"),
                desc: t("mandecar23.gender.salary-by-gender.desc"),
                descExtra: t("mandecar23.gender.salary-by-gender.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.gender.calculator.title"),
                desc: t("mandecar23.gender.calculator.desc"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gender_GenderCalculator, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.gender.salary-gender-experience.title"),
                desc: t("mandecar23.gender.salary-gender-experience.desc"),
                descExtra: t("mandecar23.gender.salary-gender-experience.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByExperience, {})
            })
        ]
    });
};
/* harmony default export */ var gender_Gender = (Gender);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/intro/Intro.constants.tsx

var NAVDATA = function(t) {
    return [
        {
            section: "talent",
            img: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/talent-nav.jpg"),
            text: t("mandecar23.nav.talent")
        },
        {
            section: "benefits",
            img: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/benefits-nav.jpg"),
            text: t("mandecar23.nav.benefits")
        },
        {
            section: "companies",
            img: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/companies-nav.jpg"),
            text: t("mandecar23.nav.companies")
        },
        {
            section: "gender",
            img: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/gender-nav.jpg"),
            text: t("mandecar23.nav.talent-management")
        }
    ];
};
var INTRODATA = function(t, locale, manfreditesCount) {
    return [
        {
            value: manfreditesCount.toLocaleString(locale),
            text: t("mandecar23.data.people")
        },
        {
            value: "+12.000",
            text: t("mandecar23.data.current")
        },
        {
            value: "40%",
            text: t("mandecar23.data.companies")
        },
        {
            value: "+500",
            text: t("mandecar23.data.time-to-hire")
        }
    ];
};

// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(28870);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/intro/Intro.styled.tsx

function Intro_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    Intro_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(",
        ", ",
        "),\n    url('",
        "');\n  background-size: cover;\n  background-position: top center;\n  padding: ",
        " ",
        " ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    background-image: linear-gradient(",
        ", ",
        "),\n      url('",
        "');\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  &::after {\n    background-image: linear-gradient(transparent, ",
        ");\n    content: '';\n    display: block;\n    width: calc(100% + ",
        ");\n    height: 20rem;\n    position: absolute;\n    bottom: 0;\n    left: -",
        ";\n    right: -",
        ";\n  }\n"
    ]);
    Intro_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n  z-index: 1;\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.4;\n  }\n"
    ]);
    Intro_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  span {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 1;\n    text-transform: uppercase;\n    font-weight: ",
        ";\n    letter-spacing: 0.35em;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  .year {\n    font-family: inherit;\n    font-size: ",
        ";\n    letter-spacing: 0;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: 10rem;\n    }\n  }\n"
    ]);
    Intro_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  margin-top: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    Intro_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  a {\n    color: inherit;\n  }\n"
    ]);
    Intro_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  font-size: ",
        ";\n  line-height: 1.25;\n  font-weight: ",
        ";\n  border-radius: ",
        ";\n  position: relative;\n  overflow: hidden;\n  transition: 0.3s;\n  max-width: 18rem;\n  margin: auto;\n  aspect-ratio: 1 / 1;\n\n  @media (min-width: ",
        ") {\n    max-width: auto;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.1666;\n  }\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  span {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: ",
        ";\n    padding: ",
        " ",
        ";\n    min-height: 4.75em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    Intro_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  font-size: ",
        ";\n  line-height: 1.5;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    Intro_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin-top: 0;\n  color: ",
        ";\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  &::before,\n  &::after {\n    content: '';\n    height: 1px;\n    background-color: ",
        ";\n    flex-grow: 1;\n  }\n"
    ]);
    Intro_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n\n  @media (min-width: ",
        ") {\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  width: 8rem;\n  flex-shrink: 0;\n  text-align: right;\n\n  @media (min-width: ",
        ") {\n    width: auto;\n    text-align: center;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    width: ",
        ";\n    height: ",
        ";\n    background-color: currentColor;\n\n    @media (min-width: ",
        ") {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-0"
})(Intro_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("text_white"));
var Intro_styled_StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-1"
})(Intro_styled_templateObject1(), (0,polished_esm/* rgba */.m4)("#000", 0), (0,polished_esm/* rgba */.m4)("#000", 0.7), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg-sm.webp"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,polished_esm/* rgba */.m4)("#000", 0), (0,polished_esm/* rgba */.m4)("#000", 0.7), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg.webp"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-2"
})(Intro_styled_templateObject2(), (0,theme/* container */.nC)("lg"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var Intro_styled_StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading1 */.nL).withConfig({
    componentId: "sc-66d3eb51-3"
})(Intro_styled_templateObject3(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl7"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontSize */.JB)("xl8"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl10"), (0,theme/* screen */.sp)("lg"));
var StyledNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-4"
})(Intro_styled_templateObject4(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledNavList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-5"
})(Intro_styled_templateObject5(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledNavItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-6"
})(Intro_styled_templateObject6(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* color */.$_)("navy_500"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-7"
})(Intro_styled_templateObject7(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));
var Intro_styled_StyledDataTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-66d3eb51-8"
})(Intro_styled_templateObject8(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_300"));
var Intro_styled_StyledDataList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var Intro_styled_StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66d3eb51-10"
})(_templateObject10(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xs"));
var Intro_styled_StyledDataValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-66d3eb51-11"
})(_templateObject11(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("md"));
var StyledDataContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-66d3eb51-12"
})(_templateObject12(), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/intro/Intro.tsx








var Intro = function(param) {
    var manfreditesCount = param.manfreditesCount;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locale = (0,router.useRouter)().locale;
    var navData = NAVDATA(t);
    var introData = INTRODATA(t, locale, manfreditesCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIntro, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledHero, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledHeroContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledHeroTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("mandecar23.hero.pre-title")
                                }),
                                t("mandecar23.hero.title"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "year",
                                    children: "2023"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2023",
                            i18nKey: "mandecar23.hero.desc"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNav, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                        children: t("mandecar23.nav.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavList, {
                        children: navData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                to: item.section,
                                href: "#".concat(item.section),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: item.img,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.text
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledData, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledDataTitle, {
                        children: t("mandecar23.data.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "developer-career-report-2023",
                        i18nKey: "mandecar23.data.desc"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledDataList, {
                        children: introData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledDataValue, {
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataContent, {
                                        children: item.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var intro_Intro = (Intro);

// EXTERNAL MODULE: ./components/shared/accordion/Accordion.tsx
var Accordion = __webpack_require__(71652);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/charts/ MethodologyExperience.tsx




var MethodologyExperience = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 180,
                width: "99%",
                minWidth: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: METHODOLOGYEXPERIENCE,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "exp",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5,
                            fill: "#35B7B2"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var _MethodologyExperience = (MethodologyExperience);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/PieChart.js
var PieChart = __webpack_require__(43454);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/Pie.js
var Pie = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Cell.js
var Cell = __webpack_require__(11011);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/charts/MethodologyGender.tsx





var MethodologyGender = function() {
    var locale = (0,router.useRouter)().locale;
    var methodologyGender = METHODOLOGYGENDER(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology gender",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 400,
                height: 400,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                        layout: "vertical",
                        align: "right",
                        verticalAlign: "top",
                        iconType: "square",
                        width: 120
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        labelStyle: {
                            display: "none"
                        },
                        separator: ": ",
                        formatter: function(value) {
                            return value.toFixed(1) + "%";
                        },
                        wrapperClassName: "tooltip-y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: methodologyGender,
                        dataKey: "value",
                        cx: "50%",
                        cy: "28%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#1B9D76"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyGender = (MethodologyGender);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/charts/MethodologyRoles.tsx




var MethodologyRoles = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 330,
                width: "99%",
                minWidth: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: METHODOLOGYROLES,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 160
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5,
                            fill: "#35B7B2"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyRoles = (MethodologyRoles);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/Methodology.constants.tsx






var genderAccordion = function(t) {
    return [
        {
            summary: t("mandecar23.methodology.gender.api-title"),
            details: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "developer-career-report-2023",
                i18nKey: "mandecar23.methodology.gender.api-content"
            })
        },
        {
            summary: t("mandecar23.methodology.gender.question-title"),
            details: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "developer-career-report-2023",
                i18nKey: "mandecar23.methodology.gender.question-content"
            })
        }
    ];
};
var METHODOLOGYSECTIONS = function(t) {
    return [
        {
            title: t("mandecar23.methodology.experience.title"),
            desc: "mandecar23.methodology.experience.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(_MethodologyExperience, {})
        },
        {
            title: t("mandecar23.methodology.roles.title"),
            desc: "mandecar23.methodology.roles.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyRoles, {})
        },
        {
            title: t("mandecar23.methodology.gender.title"),
            desc: "mandecar23.methodology.gender.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyGender, {}),
            accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                items: genderAccordion(t)
            })
        }
    ];
};
var METHODOLOGYEXPERIENCE = [
    {
        exp: "<2y",
        share: 11.998053054271113
    },
    {
        exp: "2-5y",
        share: 16.776182363916607
    },
    {
        exp: "5-10y",
        share: 14.969849382115141
    },
    {
        exp: ">10y",
        share: 18.179605743489898
    }
];
var METHODOLOGYROLES = [
    {
        role: "Backend Developer",
        share: 17.406480709233
    },
    {
        role: "Full-stack Developer",
        share: 13.310474778364686
    },
    {
        role: "Frontend Developer",
        share: 13.08188922867822
    },
    {
        role: "Tech Lead",
        share: 3.916844283816761
    },
    {
        role: "Project & Delivery Manager",
        share: 3.4457727118277575
    },
    {
        role: "DevOps & Infra. & SRE",
        share: 3.147684799060946
    },
    {
        role: "Software Architect",
        share: 2.8773978315262716
    },
    {
        role: "Mobile Developer",
        share: 2.67197973619992
    },
    {
        role: "Engineering Management",
        share: 2.1854631946375065
    },
    {
        role: "Data Analysis & BI",
        share: 2.1777407098508017
    }
];
var METHODOLOGYGENDER = function(locale) {
    return [
        {
            name: locale === "es" ? "Mujeres" : "Women",
            value: 13.436102388428965
        },
        {
            name: locale === "es" ? "Hombres" : "Men",
            value: 77.26710438671614
        },
        {
            name: locale === "es" ? "Indeterminado" : "Unknown",
            value: 8.583119231135218
        }
    ];
};

// EXTERNAL MODULE: ./components/shared/accordion/Accordion.styled.tsx
var Accordion_styled = __webpack_require__(28619);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/Methodology.styled.tsx

function Methodology_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Methodology_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: left;\n  padding: ",
        " ",
        ";\n"
    ]);
    Methodology_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.6;\n"
    ]);
    Methodology_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    Methodology_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 22rem;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  flex-grow: 1;\n\n  p {\n    margin-top: 0;\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    border: 1px solid ",
        ";\n    border-radius: ",
        ";\n  }\n\n  ",
        ":first-child {\n    ",
        " {\n      border-top: 0;\n    }\n  }\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    Methodology_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n  padding-top: ",
        ";\n\n  a {\n    font-weight: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32742d99-0"
})(Methodology_styled_templateObject(), (0,theme/* color */.$_)("white"));
var Methodology_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32742d99-1"
})(Methodology_styled_templateObject1(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var Methodology_styled_StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-32742d99-2"
})(Methodology_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"));
var Methodology_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32742d99-3"
})(Methodology_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"));
var StyledSectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32742d99-4"
})(Methodology_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), Accordion_styled/* StyledAccordion */.sB, (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("md"), Accordion_styled/* StyledAccordionItem */.wW, Accordion_styled/* StyledSummary */.WQ, Accordion_styled/* StyledTrigger */.tr, (0,theme/* spacing */.W0)("md"), Accordion_styled/* StyledTitle */.X0, (0,theme/* fontSize */.JB)("md"), Accordion_styled/* StyledContent */.Hz, (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledSectionTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-32742d99-5"
})(Methodology_styled_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledSectionChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32742d99-6"
})(Methodology_styled_templateObject6());
var StyledThanks = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-32742d99-7"
})(Methodology_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/MethodologySection.tsx



var MethodologySection = function(param) {
    var title = param.title, desc = param.desc, chart = param.chart, accordion = param.accordion;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2023",
                            i18nKey: desc
                        })
                    }),
                    accordion && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: accordion
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionChart, {
                children: chart
            })
        ]
    });
};
/* harmony default export */ var methodology_MethodologySection = (MethodologySection);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/methodology/Methodology.tsx







var Methodology = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var sections = METHODOLOGYSECTIONS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                    editorial: true,
                    alignLeft: true,
                    as: "h5",
                    children: t("mandecar23.methodology.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Methodology_styled_StyledDesc, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "developer-career-report-2023",
                        i18nKey: "mandecar23.methodology.desc"
                    })
                }),
                sections.map(function(section, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_MethodologySection, {
                        title: section.title,
                        desc: section.desc,
                        chart: section.chart,
                        accordion: section.accordion
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledThanks, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "developer-career-report-2023",
                        i18nKey: "mandecar23.methodology.thanks"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var methodology_Methodology = (Methodology);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/LeastWantedTechsByFrameworks.tsx





var LeastWantedTechsByFrameworks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: LEASTWANTEDTECHSBYFRAMEWORKS,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_LeastWantedTechsByFrameworks = (LeastWantedTechsByFrameworks);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/LeastWantedTechsByLanguage.tsx





var LeastWantedTechsByLanguage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: LEASTWANTEDTECHSBYLANGUAGE,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_LeastWantedTechsByLanguage = (LeastWantedTechsByLanguage);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/LeastWantedTechsByOther.tsx





var LeastWantedTechsByOther = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: LEASTWANTEDTECHSBYOTHER,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_LeastWantedTechsByOther = (LeastWantedTechsByOther);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/MostUsedTechsByFrameworks.tsx





var MostUsedTechsByFrameworks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: MOSTUSEDTECHSBYFRAMEWORKS,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostUsedTechsByFrameworks = (MostUsedTechsByFrameworks);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/MostUsedTechsByLanguage.tsx





var MostUsedTechsByLanguage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: MOSTUSEDTECHSBYLANGUAGE,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostUsedTechsByLanguage = (MostUsedTechsByLanguage);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/MostUsedTechsByOther.tsx





var MostUsedTechsByOther = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    width: "99%",
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: MOSTUSEDTECHSBYOTHER,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    6
                                ],
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostUsedTechsByOther = (MostUsedTechsByOther);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/ExperienceByRole.styled.tsx

function ExperienceByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n"
    ]);
    ExperienceByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExperienceByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  &.experience-table {\n    max-width: ",
        ";\n  }\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ExperienceByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 4.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ExperienceByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ea56a20-0"
})(ExperienceByRole_styled_templateObject());
var ExperienceByRole_styled_StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-6ea56a20-1"
})(ExperienceByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var ExperienceByRole_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ea56a20-2"
})(ExperienceByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("ylgnbu_02"), (0,theme/* color */.$_)("ylgnbu_03"), (0,theme/* color */.$_)("ylgnbu_04"), (0,theme/* color */.$_)("ylgnbu_05"), (0,theme/* color */.$_)("ylgnbu_06"), (0,theme/* color */.$_)("ylgnbu_07"), (0,theme/* color */.$_)("ylgnbu_08"), (0,theme/* color */.$_)("ylgnbu_09"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/ExperienceByRole.tsx




var ExperienceByRole = function(param) {
    var data = param.data;
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledTable, {
                className: "experience-table",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "<2y"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "2-5y"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "5-10y"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: ">10y"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: data.map(function(data, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: data.tech
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier1),
                                            children: [
                                                data.tier1.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier2),
                                            children: [
                                                data.tier2.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier3),
                                            children: [
                                                data.tier3.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier4),
                                            children: [
                                                data.tier4.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var talent_ExperienceByRole = (ExperienceByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/Talent.constants.tsx








var Talent_constants_HERODATA = function(t) {
    return [
        {
            value: "16.5%",
            desc: t("mandecar23.talent.hero.key-point-1")
        },
        {
            value: "48%",
            desc: t("mandecar23.talent.hero.key-point-2")
        },
        {
            value: "42.9%",
            desc: t("mandecar23.talent.hero.key-point-3")
        },
        {
            value: "27%",
            desc: t("mandecar23.talent.hero.key-point-4")
        }
    ];
};
var MOSTUSEDTECHSTABS = function(t) {
    return {
        tabsName: "mostUsedTechs",
        tabs: [
            {
                id: "mostUsedTechsByLang",
                label: t("mandecar23.talent.most-used-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByLanguage, {})
            },
            {
                id: "mostUsedTechsByFrameworks",
                label: t("mandecar23.talent.most-used-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByFrameworks, {})
            },
            {
                id: "mostUsedTechsByOther",
                label: t("mandecar23.talent.most-used-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByOther, {})
            }
        ]
    };
};
var MOSTUSEDTECHSBYLANGUAGE = [
    {
        value: 16.504588787219785,
        language: "JavaScript",
        fill: "#08306B"
    },
    {
        value: 11.636781420540807,
        language: "HTML",
        fill: "#08306B"
    },
    {
        value: 11.624471708177753,
        language: "CSS",
        fill: "#08519C"
    },
    {
        value: 10.330584164238918,
        language: "JAVA",
        fill: "#08519C"
    },
    {
        value: 9.753395428993477,
        language: "Python",
        fill: "#2171B5"
    },
    {
        value: 7.748280059633718,
        language: "SQL",
        fill: "#2171B5"
    },
    {
        value: 6.451657024058649,
        language: "PHP",
        fill: "#4292C6"
    },
    {
        value: 5.543473800828854,
        language: "TypeScript",
        fill: "#4292C6"
    },
    {
        value: 3.505532531834284,
        language: "C#",
        fill: "#6BAED6"
    },
    {
        value: 2.2020707671686295,
        language: "C++",
        fill: "#6BAED6"
    }
];
var MOSTUSEDTECHSBYFRAMEWORKS = [
    {
        value: 13.739688174428691,
        language: "React",
        fill: "#08306B"
    },
    {
        value: 6.40795498093951,
        language: "Angular2+",
        fill: "#08306B"
    },
    {
        value: 4.8609290223683415,
        language: "Bootstrap",
        fill: "#08519C"
    },
    {
        value: 4.590653300792674,
        language: "Vue",
        fill: "#08519C"
    },
    {
        value: 4.354666290163174,
        language: "Express",
        fill: "#2171B5"
    },
    {
        value: 4.04405090865084,
        language: "Spring Boot",
        fill: "#2171B5"
    },
    {
        value: 3.7818431190625064,
        language: "Spring",
        fill: "#4292C6"
    },
    {
        value: 3.5478730914298393,
        language: "jQuery",
        fill: "#4292C6"
    },
    {
        value: 3.5196353294741725,
        language: ".NET",
        fill: "#6BAED6"
    },
    {
        value: 2.9024385324431714,
        language: "Laravel",
        fill: "#6BAED6"
    }
];
var MOSTUSEDTECHSBYOTHER = [
    {
        value: 4.186463092930664,
        language: "Git",
        fill: "#08306B"
    },
    {
        value: 4.165471300721418,
        language: "MySQL",
        fill: "#08306B"
    },
    {
        value: 3.933861860012735,
        language: "NodeJS",
        fill: "#08519C"
    },
    {
        value: 3.4419541959093998,
        language: "Docker",
        fill: "#08519C"
    },
    {
        value: 3.2236395569332386,
        language: "MongoDB",
        fill: "#2171B5"
    },
    {
        value: 2.4889268296096225,
        language: "AWS",
        fill: "#2171B5"
    },
    {
        value: 2.36647470838902,
        language: "PostgreSQL",
        fill: "#4292C6"
    },
    {
        value: 2.1341655412733624,
        language: "Jira",
        fill: "#4292C6"
    },
    {
        value: 2.101278400145543,
        language: "Linux",
        fill: "#6BAED6"
    },
    {
        value: 2.0215095897504076,
        language: "Github",
        fill: "#6BAED6"
    }
];
var LEASTWANTEDTECHSTABS = function(t) {
    return {
        tabsName: "leastWantedTechs",
        tabs: [
            {
                id: "leastWantedTechsByLang",
                label: t("mandecar23.talent.least-wanted-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByLanguage, {})
            },
            {
                id: "leastWantedTechsByFrameworks",
                label: t("mandecar23.talent.least-wanted-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByFrameworks, {})
            },
            {
                id: "leastWantedTechsByOther",
                label: t("mandecar23.talent.least-wanted-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByOther, {})
            }
        ]
    };
};
var LEASTWANTEDTECHSBYLANGUAGE = [
    {
        value: 27.328020134228186,
        language: "JAVA",
        fill: "#08306B"
    },
    {
        value: 21.161912751677853,
        language: "PHP",
        fill: "#08306B"
    },
    {
        value: 6.333892617449664,
        language: "C++",
        fill: "#08519C"
    },
    {
        value: 5.39010067114094,
        language: "Python",
        fill: "#08519C"
    },
    {
        value: 5.369127516778524,
        language: "C#",
        fill: "#2171B5"
    },
    {
        value: 4.865771812080537,
        language: "Cobol",
        fill: "#2171B5"
    },
    {
        value: 4.823825503355705,
        language: "JavaScript",
        fill: "#4292C6"
    },
    {
        value: 4.656040268456376,
        language: "C",
        fill: "#4292C6"
    },
    {
        value: 3.1459731543624163,
        language: "CSS",
        fill: "#6BAED6"
    },
    {
        value: 2.2441275167785233,
        language: "HTML",
        fill: "#6BAED6"
    }
];
var LEASTWANTEDTECHSBYFRAMEWORKS = [
    {
        value: 23.56164383561644,
        language: ".NET",
        fill: "#08306B"
    },
    {
        value: 17.35159817351598,
        language: "AngularJS",
        fill: "#08306B"
    },
    {
        value: 10.684931506849315,
        language: "Angular2+",
        fill: "#08519C"
    },
    {
        value: 8.812785388127855,
        language: "React",
        fill: "#08519C"
    },
    {
        value: 6.164383561643835,
        language: "jQuery",
        fill: "#2171B5"
    },
    {
        value: 3.5616438356164384,
        language: "Vue",
        fill: "#2171B5"
    },
    {
        value: 3.2420091324200913,
        language: ".Net Core",
        fill: "#4292C6"
    },
    {
        value: 2.7853881278538815,
        language: "React Native",
        fill: "#4292C6"
    },
    {
        value: 1.872146118721461,
        language: "ASP.net",
        fill: "#6BAED6"
    },
    {
        value: 1.82648401826484,
        language: "Laravel",
        fill: "#6BAED6"
    }
];
var LEASTWANTEDTECHSBYOTHER = [
    {
        value: 6.976744186046512,
        language: "WordPress",
        fill: "#08306B"
    },
    {
        value: 6.064751481988144,
        language: "Windows",
        fill: "#08306B"
    },
    {
        value: 3.146374829001368,
        language: "Autodesk 3D Studio Max",
        fill: "#08519C"
    },
    {
        value: 2.644778841769266,
        language: "SAP",
        fill: "#08519C"
    },
    {
        value: 2.5079799361605106,
        language: "NodeJS",
        fill: "#2171B5"
    },
    {
        value: 2.0519835841313268,
        language: "Oracle",
        fill: "#2171B5"
    },
    {
        value: 2.0063839489284083,
        language: "Android",
        fill: "#4292C6"
    },
    {
        value: 1.7327861377108982,
        language: "MySQL",
        fill: "#4292C6"
    },
    {
        value: 1.6415868673050615,
        language: "Azure",
        fill: "#6BAED6"
    },
    {
        value: 1.595987232102143,
        language: "Drupal",
        fill: "#6BAED6"
    }
];
var SOFTSKILLS = function(locale) {
    return [
        {
            skill: {
                en: "Team player",
                es: "Trabajo en equipo"
            },
            offers: 10.101382488479263,
            users: 10.932951678633804
        },
        {
            skill: {
                en: "Proactivity",
                es: "Proactividad"
            },
            offers: 9.253456221198157,
            users: 6.430719968950125
        },
        {
            skill: {
                en: "Continuous learning",
                es: "Aprendizaje Continuo"
            },
            offers: 8.534562211981566,
            users: 14.513390258102078
        },
        {
            skill: {
                en: "Capacity for self-management ",
                es: "Capacidad de autogesti\xf3n"
            },
            offers: 8.036866359447005,
            users: 3.927323888996701
        },
        {
            skill: {
                en: "Attention to detail",
                es: "Atenci\xf3n al detalle"
            },
            offers: 7.336405529953917,
            users: 5.5841257519891325
        },
        {
            skill: {
                en: "Adaptability to change",
                es: "Adaptabilidad al cambio"
            },
            offers: 6.63594470046083,
            users: 11.017853677469436
        },
        {
            skill: {
                en: "Good verbal communication",
                es: "Comunicaci\xf3n verbal"
            },
            offers: 5.806451612903226,
            users: 1.4748690083446536
        },
        {
            skill: {
                en: "Analytical thinking",
                es: "Pensamiento anal\xedtico"
            },
            offers: 4.9953917050691246,
            users: 7.316126528235979
        },
        {
            skill: {
                en: "Autonomy in learning",
                es: "Autonom\xeda en el aprendizaje"
            },
            offers: 4.571428571428571,
            users: 6.765476421502038
        },
        {
            skill: {
                en: "Leadership skills",
                es: "Liderazgo"
            },
            offers: 4.018433179723503,
            users: 4.327576169221812
        },
        {
            skill: {
                en: "Ability to give feedback",
                es: "Capacidad de dar feedback"
            },
            offers: 3.576036866359447,
            users: 1.4991267222976907
        },
        {
            skill: {
                en: "Strategic vision",
                es: "Visi\xf3n estrat\xe9gica"
            },
            offers: 3.336405529953917,
            users: 2.396662138560062
        },
        {
            skill: {
                en: "Good written communication",
                es: "Comunicaci\xf3n escrita"
            },
            offers: 3.299539170506913,
            users: 0.7762468464971861
        }
    ];
};
var EXPERIENCEBYROLEBYLANGUAGE = [
    {
        tech: "C#",
        tier2: 25.665236051502145,
        tier4: 35.407725321888414,
        tier3: 22.660944206008583,
        tier1: 16.266094420600858
    },
    {
        tech: "C++",
        tier1: 19.2524682651622,
        tier4: 33.779971791255285,
        tier2: 26.375176304654442,
        tier3: 20.59238363892807
    },
    {
        tech: "CSS",
        tier3: 19.70372501078671,
        tier1: 33.0504818064145,
        tier4: 18.366172875017977,
        tier2: 28.87962030778081
    },
    {
        tech: "HTML",
        tier1: 32.64981949458484,
        tier3: 20.014440433212997,
        tier4: 18.642599277978338,
        tier2: 28.693140794223826
    },
    {
        tech: "JAVA",
        tier2: 24.903187369675305,
        tier3: 22.981829014000596,
        tier1: 19.37742031575812,
        tier4: 32.73756330056598
    },
    {
        tech: "JavaScript",
        tier2: 28.375241779497102,
        tier1: 26.42166344294004,
        tier4: 23.143133462282396,
        tier3: 22.059961315280464
    },
    {
        tech: "PHP",
        tier2: 22.14968524131499,
        tier1: 16.927022615994407,
        tier3: 25.763581254371648,
        tier4: 35.159710888318955
    },
    {
        tech: "Python",
        tier3: 22.425997425997426,
        tier4: 26.512226512226512,
        tier2: 29.906692406692407,
        tier1: 21.155083655083658
    },
    {
        tech: "SQL",
        tier1: 20.30284917314206,
        tier2: 29.647340107591152,
        tier4: 27.256425582785415,
        tier3: 22.79338513648137
    },
    {
        tech: "TypeScript",
        tier2: 34.51255738590332,
        tier1: 22.306238185255197,
        tier3: 24.60167431812044,
        tier4: 18.579530110721038
    }
];
var EXPERIENCEBYROLEBYFRAMEWORK = [
    {
        tech: "Angular2+",
        tier2: 30.29197080291971,
        tier1: 15.19575315195753,
        tier3: 29.329794293297944,
        tier4: 25.18248175182482
    },
    {
        tech: "Bootstrap",
        tier3: 16.860171630489653,
        tier2: 26.653205451792022,
        tier4: 18.67743563856638,
        tier1: 37.80918727915194
    },
    {
        tech: "Express",
        tier4: 11.52310325156874,
        tier3: 16.543069024529377,
        tier2: 28.465487735310894,
        tier1: 43.468339988590984
    },
    {
        tech: "jQuery",
        tier3: 27.9322853688029,
        tier4: 35.489721886336156,
        tier1: 12.6360338573156,
        tier2: 23.941958887545344
    },
    {
        tech: "Laravel",
        tier2: 28.330781010719758,
        tier3: 27.488514548238896,
        tier4: 26.263399693721283,
        tier1: 17.917304747320063
    },
    {
        tech: ".NET",
        tier3: 25.269461077844312,
        tier1: 10.538922155688622,
        tier4: 42.93413173652695,
        tier2: 21.25748502994012
    },
    {
        tech: "React",
        tier3: 20.658263305322127,
        tier4: 16.509103641456583,
        tier1: 31.915266106442573,
        tier2: 30.917366946778714
    },
    {
        tech: "Spring",
        tier2: 23.721191680719507,
        tier4: 39.34794828555368,
        tier3: 25.576166385609895,
        tier1: 11.354693648116921
    },
    {
        tech: "Spring Boot",
        tier2: 26.35616438356164,
        tier1: 16.931506849315067,
        tier3: 24.71232876712329,
        tier4: 32
    },
    {
        tech: "Vue",
        tier2: 30.736743312998595,
        tier4: 23.04082590333177,
        tier1: 17.08118254340685,
        tier3: 29.141248240262783
    }
];
var EXPERIENCEBYROLEBYOTHER = [
    {
        tech: "AWS",
        tier2: 24.22543523163175,
        tier4: 39.74623782826793,
        tier3: 28.031867807612866,
        tier1: 7.99645913248746
    },
    {
        tech: "Docker",
        tier3: 27.82275244993609,
        tier2: 27.37537281636131,
        tier4: 33.4043459735833,
        tier1: 11.3975287601193
    },
    {
        tech: "Git",
        tier1: 22.599925289503176,
        tier3: 24.24355621964886,
        tier4: 23.47777362719462,
        tier2: 29.678744863653346
    },
    {
        tech: "Github",
        tier2: 27.516778523489933,
        tier3: 19.630872483221477,
        tier1: 34.22818791946309,
        tier4: 18.624161073825505
    },
    {
        tech: "Jira",
        tier1: 10.483042137718398,
        tier3: 28.126070572113736,
        tier2: 27.132579650565265,
        tier4: 34.258307639602606
    },
    {
        tech: "Linux",
        tier2: 23.079723334546777,
        tier4: 40.51692755733527,
        tier1: 13.214415726246814,
        tier3: 23.18893338187113
    },
    {
        tech: "MongoDB",
        tier3: 23.084455324357407,
        tier1: 25.018359853121176,
        tier2: 27.148102815177477,
        tier4: 24.749082007343944
    },
    {
        tech: "MySQL",
        tier3: 24.627720504009165,
        tier4: 30.794196258113782,
        tier2: 23.749522718594886,
        tier1: 20.82856051928217
    },
    {
        tech: "NodeJS",
        tier1: 28.674203494347378,
        tier3: 22.302158273381295,
        tier4: 20.431654676258994,
        tier2: 28.591983556012334
    },
    {
        tech: "PostgreSQL",
        tier3: 25,
        tier2: 27.706185567010312,
        tier4: 29.961340206185564,
        tier1: 17.332474226804123
    }
];
var EXPERIENCEBYROLETABS = function(t) {
    return {
        tabsName: "experienceByRole",
        tabs: [
            {
                id: "experienceByRoleByLang",
                label: t("mandecar23.talent.main-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: EXPERIENCEBYROLEBYLANGUAGE
                })
            },
            {
                id: "experienceByRoleByFramework",
                label: t("mandecar23.talent.main-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: EXPERIENCEBYROLEBYFRAMEWORK
                })
            },
            {
                id: "experienceByRoleByOther",
                label: t("mandecar23.talent.main-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: EXPERIENCEBYROLEBYOTHER
                })
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/charts/SoftSkillsCommunityVsOffered.tsx







var SoftSkillsCommunityVsOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var locale = (0,router.useRouter)().locale;
    var softSkills = SOFTSKILLS(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "skills",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    width: "99%",
                    height: 950,
                    minWidth: 500,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: softSkills,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: function(data) {
                                    return data.skill[locale || "en"];
                                },
                                tickLine: false,
                                width: 200
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "#ebe8df"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "offers",
                                name: t("mandecar23.talent.competences.companies"),
                                fill: "#7EAFD3",
                                barSize: 8,
                                radius: 5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "users",
                                name: t("mandecar23.talent.competences.community"),
                                fill: "#8DD3C7",
                                barSize: 8,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_SoftSkillsCommunityVsOffered = (SoftSkillsCommunityVsOffered);

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/Talent.styled.tsx

function Talent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Talent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Talent_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89722960-0"
})(Talent_styled_templateObject(), (0,theme/* color */.$_)("sand_100"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/components/talent/Talent.tsx









var Talent = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var heroData = Talent_constants_HERODATA(t);
    var mostUsedTechTabs = MOSTUSEDTECHSTABS(t);
    var leastWantedTechTabs = LEASTWANTEDTECHSTABS(t);
    var experienceByRoleTabs = EXPERIENCEBYROLETABS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Talent_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                background: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/talent-hero-bg.webp"),
                backgroundSm: (0,paths/* getPublicPath */.A)("/images/stateSector/2023/talent-hero-bg-sm.webp"),
                title: t("mandecar23.talent.hero.title"),
                desc: t("mandecar23.talent.hero.desc"),
                data: heroData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.talent.most-used-techs.title"),
                desc: t("mandecar23.talent.most-used-techs.desc"),
                descExtra: t("mandecar23.talent.most-used-techs.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: mostUsedTechTabs.tabsName,
                    tabs: mostUsedTechTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.talent.least-wanted-techs.title"),
                desc: t("mandecar23.talent.least-wanted-techs.desc"),
                descExtra: t("mandecar23.talent.least-wanted-techs.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: leastWantedTechTabs.tabsName,
                    tabs: leastWantedTechTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.talent.main-techs.title"),
                desc: t("mandecar23.talent.main-techs.desc"),
                descExtra: t("mandecar23.talent.main-techs.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: experienceByRoleTabs.tabsName,
                    tabs: experienceByRoleTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mandecar23.talent.competences.title"),
                desc: t("mandecar23.talent.competences.desc"),
                descExtra: t("mandecar23.talent.competences.descExtra"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SoftSkillsCommunityVsOffered, {})
            })
        ]
    });
};
/* harmony default export */ var talent_Talent = (Talent);

// EXTERNAL MODULE: ./hooks/api/manfredite/index.ts + 4 modules
var api_manfredite = __webpack_require__(33219);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/Mandecar.hook.ts






// Custom hook.
// -----------------------------------------------------------------------------
var useMandecar = function() {
    // Hooks.
    // ---------------------------------------------------------------------------
    var locale = (0,router.useRouter)().locale;
    var manfredite = (0,api_manfredite/* useManfredite */.CV)().manfredite;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    // Variables.
    // ---------------------------------------------------------------------------
    var urlCTA = (0,react.useMemo)(function() {
        return manfredite ? (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale) : "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=mandecar-23");
    }, [
        locale,
        manfredite
    ]);
    // Functions.
    // ---------------------------------------------------------------------------
    var handleOnClickCTA = (0,react.useCallback)(function(event) {
        service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(event, urlCTA, "mandecar-carrera");
    }, [
        urlCTA
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        onClickCTA: handleOnClickCTA,
        urlCTA: urlCTA
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/Mandecar.styled.ts

function Mandecar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(\n      ",
        ",\n      ",
        "\n    ),\n    url('",
        "');\n  background-size: cover;\n  background-position: top center;\n  padding: ",
        " ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-image: linear-gradient(\n        ",
        ",\n        ",
        "\n      ),\n      url('",
        "');\n  }\n"
    ]);
    Mandecar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Mandecar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    Mandecar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aff56394-0"
})(Mandecar_styled_templateObject(), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg-sm.webp"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* screen */.sp)("md"), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg.webp"));
var StyledFooterActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aff56394-1"
})(Mandecar_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/mandecar23/Mandecar.tsx






















var MandecarComponent = function(param) {
    var manfreditesCount = param.manfreditesCount;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useMandecar(), onClickCTA = ref.onClickCTA, urlCTA = ref.urlCTA;
    var locale = (0,router.useRouter)().locale;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    var ref1 = (0,react.useState)(false), isShareModalOpened = ref1[0], setIsShareModalOpened = ref1[1];
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_Intro, {
                manfreditesCount: manfreditesCount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "talent",
                id: "talent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_Talent, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "benefits",
                id: "benefits",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_Benefits, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "companies",
                id: "companies",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_Companies, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "gender",
                id: "gender",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gender_Gender, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "methodology",
                id: "methodology",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_Methodology, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: logos/* LOGO_MANFRED_WHITE */.YM,
                        alt: "Manfred logo",
                        width: "275",
                        height: "50"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("mandecar23.footer_tagline")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterActions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                variant: "secondaryInverse",
                                type: "button",
                                onClick: function() {
                                    service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("mandecar-compartir");
                                    setIsShareModalOpened(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faShareSquare */.tFX
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("mandecar23.footer-share")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                href: urlCTA,
                                schema: "brand2",
                                variant: "hard",
                                startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
                                label: t("mandecar23.footer_cta"),
                                onClick: function(event) {
                                    return onClickCTA(event);
                                }
                            })
                        ]
                    })
                ]
            }),
            isShareModalOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal["default"], {
                isOpened: isShareModalOpened,
                close: function() {
                    return setIsShareModalOpened(false);
                },
                url: "https://mnfrd.co/48fCaHM",
                emailSubject: t("mandecar23.share-modal.email-subject"),
                twitterMessage: t("mandecar23.share-modal.text"),
                telegramMessage: t("mandecar23.share-modal.text"),
                whatsappMessage: t("mandecar23.share-modal.text"),
                emailMessage: t("mandecar23.share-modal.email-text")
            })
        ]
    });
};
/* harmony default export */ var Mandecar = (MandecarComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
;// CONCATENATED MODULE: ./pages/developer-career-report-2023.tsx







var Mandecar23Page = function(param) {
    var baseUrl = param.baseUrl, manfreditesCount = param.manfreditesCount;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2023").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("mandecar23.page_title"),
                url: app_urls/* APP_URLS.mandecar23 */.uu.mandecar23,
                desc: t("mandecar23.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_developer_career_report_2023.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mandecar, {
                manfreditesCount: manfreditesCount
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var developer_career_report_2023 = (Mandecar23Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,8746,9001,2077,3004,4926,3454,625,4882,289,7566,9774,2888,179], function() { return __webpack_exec__(50755); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);